import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  deleteDataFromApi,
  postDataFromApi,
  putDataFromApi,
} from "../../services/commonServices";
import {
  CommonTMRoles,
  getActivityCode,
  getCurrentRole,
  getDayCountFromDate,
  getFormatedDate,
  getLMSOperationActivity,
  getOperationActivityListPageUrl,
  getOperationActivityUrl,
  getPurchaseManager,
  getRakeCollectionActivity,
  getRakeOperations,
  getSampleCollectionActivity,
  getStackOperations,
  getVesselOperation,
  isModuelePermission,
} from "../../services/commonFunction";
import { useDispatch, useSelector } from "react-redux";
import DeleteConfirmation from "./deleteConfirmation";
import {
  InternalCertificateDeleteApi,
  JRFDeleteApi,
  JRFPDFDownloadApi,
  SFMDeleteApi,
  allotmentDeleteApi,
  sampleInwardDetailsDeleteAPI,
  sampleverificationDeleteApi,
  testMemoDeleteApi,
  InvoiceDeleteApi,
  folderCreateApi,
  masterUploadApi,
  purchaseOrderRemindApi,
  POVendorMailApi,
  allotmentCancelApi,
  ccUpdateApi,
  InternalCertificateGetPDFApi,
} from "../../services/api";
import { ChangesLogDATA, historyData, VendorRatingDetails } from "../../actions/authActions";
import PropTypes from "prop-types";
import {
  encryptDataForURL,
  decryptDataForURL,
} from "../../utills/useCryptoUtils";
import { handleJobInstructionDelete } from "./commonHandlerFunction/jobinstructionHandlerFunctions";
import { getNonLMSDetailsById, handleDownloadCC } from "./commonHandlerFunction/OPscertificate/OPSCertificateHandlerFunctions";
import {
  handleVesselOperationDelete,
  handleDocumentDelete,
  handleCommercialCertDelete,
  handleRegenerateCertificate,
  handleDeleteCustomFormatCertificate,
} from "./commonHandlerFunction/CommercialCertificateHandlerFunctions";
import { handleConsortiumDelete } from "./commonHandlerFunction/operations/consortiumHandlerFunctions";
import { useTranslation } from "react-i18next";
import { handleGetJobCostingList } from "./commonHandlerFunction/Audit/JobCosting/JobCostingHandlerFunction";
import { getSingleBranchExpense } from "./commonHandlerFunction/Audit/BranchExpenseHandler";
import { handleGetSingleOutstanding } from "./commonHandlerFunction/Audit/OutStanding/OutStandingHandlerFunction";
import { handleGetSingleSalesRegister } from "./commonHandlerFunction/Audit/SalesRegister/SalesRegisterHandlerFunction";
import { handleSupplierDelete } from "./commonHandlerFunction/Purchase/Supplier/SupplierHandler";
import {
  handleDownloadPR,
  handlePurchaseReqDelete,
} from "./commonHandlerFunction/Purchase/PurchaseReq/PurchaseRequsitionHandler";
import { handleCalibrationDelete } from "./commonHandlerFunction/Purchase/Calibration/CalibrationHandler";
import { handleAMCDelete } from "./commonHandlerFunction/Purchase/AMC/AMCHandler";
import {
  handleDownloadPO,
  handleDownloadPOItemsExport,
  handlePurchaseOrderDelete,
} from "./commonHandlerFunction/Purchase/PurchaseOrder/PurchaseOrderHandler";
import { handleTenderDelete } from "./commonHandlerFunction/Tender/TenderHandlerFunc";
import { handleChemicalStocksDelete } from "./commonHandlerFunction/ChemicalStocks/ChemicalstockHandler";
import { handleIncentiveDelete } from "./commonHandlerFunction/Feedback/IncentiveHandler";
import { handleCreateDebitFromList, handleDownloadDraftInvoice } from "./commonHandlerFunction/InvoiceHandlerFunctions";
import { handlePurchaseItemDelete } from "./commonHandlerFunction/Purchase/Items/ItemsHandler";
import {
  handleCategoryDelete,
  handleCategorykDelete,
} from "./commonHandlerFunction/Purchase/Category/CategoryHandler";
import { handleBranchMasterDelete } from "./commonHandlerFunction/Purchase/DepartmentandBranchHandler/BrachnHandler";
import { handleDepartmentDelete } from "./commonHandlerFunction/Purchase/DepartmentandBranchHandler/DepartmentHandler";
import { handleCreditNoteDelete } from "./commonHandlerFunction/Collections/CreditNoteHandler";
import { handleTransferStocksDelete } from "./commonHandlerFunction/TransferStocks/TransferStocksHandler";
import RejectPopupModal from "./rejectPopupModal";
import CustomPopupModal from "./commonModalForms/CustomPopupModal";
import { handleAmendmentInitiateAmendement, handleAmenIntarnalCertificateCreateUpdate } from "./commonHandlerFunction/intenralCertificateHandlerFunction";
import { handleLabParamDelete } from "./commonHandlerFunction/Parameter/ParameterHandler";

const PopupOptions = ({
  popupActions,
  setPopupIndex,
  id,
  row,
  section,
  getAllListingData,
  setFormData,
  formConfig,
  type,
  sampleInwardFormId,
  model,
  isBottom,
  status,
  setDontClick,
  from,
  setPopupType,
  operationMode,
  formData,
  setIsOverlayLoader,
  setIsCustomPopup,
  setClickedRow,
  handleDownloadCertificateAfterPublish,
  setIsCancelRemarkOpen,
  setCancelRemark,
  cancelSaId,
  isCancelRemarkOpen,
  setCancelSaId,
  cancelRemark,
  isCustomPopupModal,
  setIsCustomPopupModal,
  setSelectedSingleRow,
  setUploadPopup,
  setIsDownLoadPopup
}) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const translate = t;
  let user;
  const session = useSelector((state) => state.session);
  user = session?.user;
  let rolePermissions;
  rolePermissions = session?.user?.permissions;

  const hash = window.location.hash;
  const params = new URLSearchParams(hash.split("?")[1]);
  let OperationType = decryptDataForURL(params.get("OperationType"));
  OperationType = getActivityCode(OperationType);
  OperationType =
    OperationType && OperationType.toLowerCase() != "othertpi"
      ? OperationType.toLowerCase()
      : OperationType;

  const [actions, setActions] = useState(popupActions);
  const [isDelete, setIsDelete] = useState(false);
  const [actionType, setActionType] = useState(false);

  const moduleType = formConfig?.listView?.moduleType;

  const subModuleType = formConfig?.listView?.subModuleType;
  const uploadExtraModules = [
    "tenderDocumentList",
    "purchaseorderDocumentList",
    "purchasereqDocumentList",
    "jrfDocumentList",
    "itemDocumentList",
    "creditNoteDocumentList",
    "OnAccountDocumentList",
    "verificationDocumentList",
    "JobCostingDocumentList",
    "transferStockDocumentList"
  ];

  const handleClick = async (value, actionType = "") => {
    setActionType(value);
    setDontClick(true);
    if (!actionType && value.toLowerCase() === "rake details") {
      if (
        getLMSOperationActivity().includes(
          getActivityCode(
            row["activity_master"]["activity_code"],
          ).toLowerCase(),
        )
      ) {
        navigate(
          getOperationActivityUrl(operationMode) +
          encryptDataForURL(row["fk_jiid"]) +
          "/" +
          encryptDataForURL(row["activity_master"]["activity_code"]) +
          "?OperationType=" +
          encryptDataForURL(row["activity_master"]["activity_code"]) +
          "&operationId=" +
          encryptDataForURL(row["jis_id"]) +
          "&operationStepNo=" +
          encryptDataForURL(7) +
          "&action=" +
          encryptDataForURL("opsView") +
          "&operationMode=" +
          encryptDataForURL(operationMode) +
          "&isRakeDetails=" +
          encryptDataForURL(1),
        );
      } else {
        navigate(
          section.redirectUrl +
          encryptDataForURL(formData[0]?.["ji_id"]) +
          "/" +
          encryptDataForURL(row["activity_master"]["activity_code"]) +
          "?OperationType=" +
          encryptDataForURL(row["activity_master"]["activity_code"]) +
          "&operationId=" +
          encryptDataForURL(row["jis_id"]) +
          "&operationStepNo=" +
          encryptDataForURL(2) +
          "&operationMode=" +
          encryptDataForURL(
            formData[0]?.operation_type?.operation_type_code,
          ) +
          "&isRakeDetails=" +
          encryptDataForURL(1),
        );
      }
      return;
    }

    if (moduleType === "sampleinward") {
      if (actionType === "View") {
        navigate(
          `/inwardList/inwardForm?status=${encryptDataForURL(
            value,
          )}&id=${encryptDataForURL(id)}&sampleInwardId=${encryptDataForURL(
            sampleInwardFormId,
          )}&action=${encryptDataForURL("View")}`,
        );
      } else if (value === "History") {
        const historyDetails = {
          recordNo: "Inward No " + row.smpl_inward_number,
          model: model,
          redirect: "/inwardList",
          Breadcrumb: "Sample Inward List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL(
            value,
          )}&id=${encryptDataForURL(row["smpl_inwrd_id"])}`,
        );

        setPopupIndex(-1);
      } else if (value === "assignmentview") {
        navigate(
          "/inwardList/groupAssignmentPreview?status=" +
          encryptDataForURL("assignment") +
          "&sampleInwardId=" +
          encryptDataForURL(sampleInwardFormId) +
          "&id=" +
          encryptDataForURL(id),
        );
      } else if (value === "Delete") {
        setIsDelete(true);
      } else if (value === "Edit Assignment") {
        navigate(
          '/inwardList/groupAssignment' +
          "?status=" +
          encryptDataForURL('assignment') +
          "&sampleInwardId=" +
          encryptDataForURL(row['smpl_inwrd_id']) +
          "&id=" +
          encryptDataForURL(row['smpl_jrf_id']) + '&useFor=' + encryptDataForURL('testmethodchange'),
        );
        return
      } else if (actionType === "Change Logs") {
        const historyDetails = {
          model: model,
          Breadcrumb: "Sample Inward List",
          data: row.smpl_audit_history,
          redirect: "/inwardList",
        };

        dispatch(ChangesLogDATA(historyDetails));
        navigate(`/su-history-logs`);
      } else {
        navigate(
          `/inwardList/inwardForm?status=${encryptDataForURL(
            value,
          )}&id=${encryptDataForURL(id)}&sampleInwardId=${encryptDataForURL(
            sampleInwardFormId,
          )}&action=${encryptDataForURL("Edit")}`,
        );
      }
    } else if (moduleType === "testmemomain") {
      if (value === "Delete") {
        setIsDelete(true);
      } else if (value === "View") {
        navigate(
          `/testmemoList/testmemo?view=${encryptDataForURL(
            "view",
          )}&status=${encryptDataForURL(
            "testMemo",
          )}&testMemoId=${encryptDataForURL(row["tm_id"])}`,
        );
      } else if (value === "History") {
        const historyDetails = {
          recordNo: "Test Memo No " + row.tm_number,
          model: model,
          redirect: "/testmemoList",
          Breadcrumb: "Test Memo List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL(
            value,
          )}&id=${encryptDataForURL(row["tm_id"])}`,
        );

        setPopupIndex(-1);
      } else if (value === "PDF") {
        const historyDetails = {
          recordNo: "Test Memo No " + row.tm_number,
          model: model,
          redirect: "/testmemoList",
          Breadcrumb: "Test Memo List",
        };
        dispatch(historyData(historyDetails));
        const encryptedValue = encryptDataForURL(value);
        const encryptedId = encryptDataForURL(row["tm_id"]);
        navigate(
          `/testmemoList/testmemoPDF?status=${encryptedValue}&id=${encryptedId}`,
        );

        setPopupIndex(-1);
      } else if (value === "Edit") {
        navigate(
          `/testmemoList/testmemo?view=${encryptDataForURL(
            "Edit",
          )}&status=${encryptDataForURL(
            "verifytestresult",
          )}&testMemoId=${encryptDataForURL(row["tm_id"])}`,
        );
      } else if (value === "Change Logs") {
        const historyDetails = {
          model: model,
          Breadcrumb: "Test Memo List",
          data: row.tm_audit_history,
          redirect: "/testmemoList",
        };
        dispatch(ChangesLogDATA(historyDetails));
        navigate(`/su-history-logs`);

        setPopupIndex(-1);
      } else {
        navigate(`/testmemoList`);
      }
    } else if (moduleType === "allotment") {
      if (value === "View") {
        navigate(
          `/allotmentList/allotment?view=${encryptDataForURL(
            "view",
          )}&status=${encryptDataForURL(
            "allotment",
          )}&sampleAllotmentId=${encryptDataForURL(row["sa_id"])}`,
        );
      } else if (value === "Edit") {
        navigate(
          "/allotmentList/allotment?status=" +
          encryptDataForURL("Edit") +
          "&sampleAllotmentId=" +
          encryptDataForURL(row["sa_id"]),
        );
      } else if (value === "Delete") {
        setIsDelete(true);
      } else if (value === "History") {
        const historyDetails = {
          recordNo: "Allotment No " + row.tm_number,
          model: model,
          redirect: "/allotmentList",
          Breadcrumb: "Allotment List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL(
            value,
          )}&id=${encryptDataForURL(row["sa_id"])}`,
        );

        setPopupIndex(-1);
      } else if (value === "Change Logs") {
        const historyDetails = {
          model: model,
          Breadcrumb: "Allotment List",
          data: row.sa_audit_history,
          redirect: "/allotmentList",
        };
        dispatch(ChangesLogDATA(historyDetails));
        navigate(`/su-history-logs`);

        setPopupIndex(-1);
      } else if (value === "Cancel") {
        setCancelSaId(row["sa_id"]);
        setIsCancelRemarkOpen(true);
      } else {
        navigate(`/testmemoList`);
      }
    } else if (moduleType === "sampleverification") {
      if (value === "View") {
        navigate(
          `/verificationList/sampleVerification?view=${encryptDataForURL(
            "view",
          )}&status=${encryptDataForURL(
            "verification",
          )}&sampleVarificationId=${encryptDataForURL(row["sv_id"])}`,
        );
      } else if (value === "History") {
        const historyDetails = {
          recordNo: "Verification No " + row.sv_verificationno,
          model: model,
          redirect: "/verificationList",
          Breadcrumb: "Verification List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL(
            value,
          )}&id=${encryptDataForURL(row["sv_id"])}`,
        );

        setPopupIndex(-1);
      } else if (value === "Delete") {
        setIsDelete(true);
      }
      else if (value === "Documents") {

        navigate("/verificationList/verification-document-list/" + encryptDataForURL(row?.sv_id));
      } else {
        navigate(`/testmemoList`);
      }
    } else if (moduleType === "sfm") {
      if (value === "View") {
        navigate(
          `/SFMList/result?view=${encryptDataForURL(
            "view",
          )}&status=${encryptDataForURL("SFMResult")}&sfmid=${encryptDataForURL(
            row["sfm_id"],
          )}`,
        );
      } else if (value === "PDF") {
        const historyDetails = {
          recordNo: "SFM No " + row.sfm_msfm_no,
          model: model,
          redirect: "/SFMList",
          Breadcrumb: "SFM List",
        };
        dispatch(historyData(historyDetails));
        const encryptedValue = encryptDataForURL(value);
        const encryptedId = encryptDataForURL(row["sfm_id"]);
        navigate(`/SFMList/SFMPDF?status=${encryptedValue}&id=${encryptedId}`);

        setPopupIndex(-1);
      } else if (value === "History") {
        const historyDetails = {
          recordNo: "SFM No " + row.sfm_msfm_no,
          model: model,
          redirect: "/SFMList",
          Breadcrumb: "SFM List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL(
            value,
          )}&id=${encryptDataForURL(row["sfm_id"])}`,
        );

        setPopupIndex(-1);
      } else if (value === "PDF") {
        const historyDetails = {
          recordNo: "SFM No " + row.sfm_msfm_no,
          model: model,
          redirect: "/SFMList",
          Breadcrumb: "SFM List",
        };
        dispatch(historyData(historyDetails));
        navigate(`/SFMPDF?status=${value}&id=${row["sfm_id"]}`);

        setPopupIndex(-1);
      } else if (value === "Delete") {
        setIsDelete(true);
      } else if (value === "Edit") {
        navigate(
          `/SFMList/result?&status=${encryptDataForURL("SFMResult")}&sfmid=${encryptDataForURL(
            row["sfm_id"],
          )}`,
        );
      } else if (value === "Change Logs") {
        const historyDetails = {
          model: model,
          Breadcrumb: "SFM List",
          data: row.sfm_audit_history,
          redirect: "/SFMList",
        };

        dispatch(ChangesLogDATA(historyDetails));
        navigate(`/su-history-logs`);
      } else {
        navigate(`/testmemoList`);
      }
    } else if (moduleType === "internalcertificate") {
      if (value === "View") {
        navigate(
          `/testReport/test-results?view=${encryptDataForURL(
            "view",
          )}&status=${encryptDataForURL(
            "testmemoresult",
          )}&editId=${encryptDataForURL(row["ic_id"])}`,
        );
      } else if (value === "History") {
        const historyDetails = {
          recordNo: "ULR No " + row.ic_ulrno,
          model: model,
          redirect: "/testReport",
          Breadcrumb: "Test Report List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL(
            value,
          )}&id=${encryptDataForURL(row["ic_id"])}`,
        );

        setPopupIndex(-1);
      } else if (value === "Edit") {
        navigate(
          `/testReport/test-results?status=${encryptDataForURL(
            "testmemoresult",
          )}&editId=${encryptDataForURL(row["ic_id"])}`,
        );
      } else if (value === "Delete") {
        setIsDelete(true);
      } else if (["With OCR Report", "Preview Report", "Download Report"].includes(value)) {
        if (['With OCR Report'].includes(value)) {
          try {
            setIsOverlayLoader(true);
            let payload, generateCertificateResponse, pdfFileName;
            payload = {
              ic_id: row.ic_id,
              is_ocr: false
            };
            generateCertificateResponse = await postDataFromApi(
              InternalCertificateGetPDFApi,
              payload,
              "",
              true,
              "",
              ""
            );
            if (generateCertificateResponse.status == 200 && generateCertificateResponse && generateCertificateResponse.data) {
              if (row.ic_ulrno) {
                pdfFileName = `${row.ic_ulrno}`;
              }
              else {
                pdfFileName = `${row.ic_refenence}`;
              }
              pdfFileName = pdfFileName + ".pdf";
              const pdfBlob = new Blob([generateCertificateResponse.data], {
                type: "application/pdf",
              });
              const pdfUrl = URL.createObjectURL(pdfBlob);

              // Create a link element
              const link = document.createElement("a");
              link.href = pdfUrl;

              // Set the filename for the download
              link.download = pdfFileName;
              // Programmatically click the link to trigger the download
              document.body.appendChild(link);
              link.click();

              // Clean up by removing the link and revoking the object URL
              document.body.removeChild(link);
              URL.revokeObjectURL(pdfUrl);
            }
          } catch (error) {
            console.error("Error fetching PDF:", error);
          }
          finally {
            setIsOverlayLoader(false);
          }
          return
        }
        else if (["Download Report"].includes(value)) {
          setIsCustomPopup(true);
          setIsDownLoadPopup(true);
          setClickedRow(row);
          return
        }
        navigate(
          `/testReport/previewPDF/${encryptDataForURL(row["ic_id"])}` +
          "?ReferenceNo=" +
          encryptDataForURL(row?.ic_refenence) + "&is_OCR=" + encryptDataForURL(value === "With OCR Report"),
        );
        // navigate(`/testReport/preview/${encryptDataForURL(row["ic_id"])}`);
        // handleTestReport(row);
      } else if (value === "Change Logs") {
        const historyDetails = {
          model: model,
          Breadcrumb: "Test Report List",
          data: row.ic_audit_history,
          redirect: "/testReport",
        };

        dispatch(ChangesLogDATA(historyDetails));
        navigate(`/su-history-logs`);
      }
      else if (value === "Amendment Report") {
        navigate(
          `/testReport/test-results?status=${encryptDataForURL(
            "testmemoresult",
          )}&editId=${encryptDataForURL(row["ic_id"])}&is_amendment=${encryptDataForURL(true)}`,
        );
      }
      else if (value === "View Amendment") {
        navigate(
          `/testReport/test-results?view=${encryptDataForURL(
            "view",
          )}&status=${encryptDataForURL(
            "testmemoresult",
          )}&editId=${encryptDataForURL(row["ic_id"])}&is_amendment=${encryptDataForURL(true)}`,
        );
      }
      else if (value === "View Amendment Logs") {
        const historyDetails = {
          model: model,
          Breadcrumb: "Test Report List",
          data: row.ic_amendent_log_data,
          redirect: "/testReport",
        };

        dispatch(ChangesLogDATA(historyDetails));
        navigate(`/su-history-logs`);
      } else if (value === "Preview Amendment Report") {
        navigate(
          `/testReport/previewPDF/${encryptDataForURL(row["ic_id"])}?ReferenceNo=${encryptDataForURL(row?.ic_refenence)}&is_amendment=${encryptDataForURL(true)}`
        );
      }
      else if (value === "Initiate Amendment") {
        // navigate(
        //   `/testReport/test-results?status=${encryptDataForURL(
        //     "testmemoresult",
        //   )}&editId=${encryptDataForURL(row["ic_id"])}&is_amendment=${encryptDataForURL(true)}&is_for_request=${encryptDataForURL(true)}`,
        // );
        setIsCustomPopupModal(true)
        setSelectedSingleRow(row)
      } else {
        navigate(`/testmemoList`);
      }
    } else if (moduleType === "jrf") {
      if (value === "Delete") {
        setIsDelete(true);
      } else if (value === "Download") {
        navigate(`/jrfListing/jrf-pdf-preview/${encryptDataForURL(id)}`);
        setPopupIndex(-1);
      } else if (value === "History") {
        const historyDetails = {
          recordNo: "JRF No " + row.jrf_no,
          model: model,
          redirect: "/jrfListing",
          Breadcrumb: "JRF List",
        };

        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL(
            value,
          )}&id=${encryptDataForURL(id)}`,
        );

        setPopupIndex(-1);
      } else if (value === "Documents") {
        navigate("/jrfListing/jrf-document-list/" + encryptDataForURL(id));
      } else if (value === "All Reports") {
        handleViewAllReports(null, id);
      }
      else if (value === "Reject") {
        let redirectUrl = !row["jrf_is_ops"]
          ? "/jrfListing/inwardForm-checklist"
          : "/jrfListing/operation-inwardForm-checklist";
        navigate(
          redirectUrl +
          "?status=" +
          encryptDataForURL("checklist") +
          "&id=" +
          encryptDataForURL(id),
        );
      } else if (value === "Change Logs") {
        const historyDetails = {
          model: model,
          Breadcrumb: "JRF List",
          data: row.jrf_audit_history,
          redirect: "/jrfListing",
        };

        dispatch(ChangesLogDATA(historyDetails));
        navigate(`/su-history-logs`);
      }
      else if (value === "Request Cancellation") {
        let redirectUrl = !row["jrf_is_ops"]
          ? "/jrfListing/external-jrf"
          : "/jrfListing/operation-jrf";
        navigate(
          redirectUrl +
          "?status=" +
          encryptDataForURL("View") +
          "&id=" +
          encryptDataForURL(id) + '&useFor=' + encryptDataForURL("CancelJob"),
        );
        return
      } else if (value === "Cancel JRF") {
        let redirectUrl = !row["jrf_is_ops"]
          ? "/jrfListing/external-jrf"
          : "/jrfListing/operation-jrf";
        navigate(
          redirectUrl +
          "?status=" +
          encryptDataForURL("View") +
          "&id=" +
          encryptDataForURL(id) + '&useFor=' + encryptDataForURL("CancelJob"),
        );
        return
      } else {
        if (row.jrf_is_external) {
          navigate(
            `/jrfListing/external-jrf?status=${encryptDataForURL(
              value,
            )}&id=${encryptDataForURL(id)}`,
          );
        } else if (row.jrf_is_ops) {
          navigate(
            `/jrfListing/operation-jrf?status=${encryptDataForURL(
              value,
            )}&id=${encryptDataForURL(id)}`,
          );
        } else {
          navigate(
            `/jrfListing/jrf?status=${encryptDataForURL(
              value,
            )}&id=${encryptDataForURL(id)}`,
          );
        }
        setPopupIndex(-1);
      }
    } else if (
      moduleType === "jobinstruction" ||
      moduleType === "jioperationjsonb" ||
      moduleType === "invoice"
    ) {
      if (
        ["invoice", "CreditNoteList", "collection-dashboard", 'PaymentDetails'].includes(
          subModuleType,
        )
      ) {
        if (
          ['PaymentDetails'].includes(
            subModuleType,
          )
        ) {
          navigate(
            `/collections/payment-list/details/${encryptDataForURL(
              row["im_id"],
            )}` +
            "?status=" +
            encryptDataForURL(value),
          );
          setPopupIndex(-1);
        }
        else if (["Edit", "View"].includes(value)) {
          let qString = `?status=${encryptDataForURL(value)}`
          if (['SU'].includes(getCurrentRole()) && value === "Edit") {
            qString = `?status=${encryptDataForURL('View')}&useForEdit=${encryptDataForURL(1)}`
          }
          navigate(
            `/operation/invoice-listing/create-invoice/${encryptDataForURL(
              row["im_id"]
            )}${qString}`
          );
          setPopupIndex(-1);
        } else if (["Delete"].includes(value)) {
          handleInvoiceDelete();
          setPopupIndex(-1);
        } else if (["Create Debit Note"].includes(value)) {

          // navigate(
          //   `/operation/invoice-listing/invoice-preview/${encryptDataForURL(
          //     row["im_id"]
          //   )}/${encryptDataForURL(
          //     row["im_invoiceurl"]
          //   )}/${encryptDataForURL(
          //     row["im_invoicenumber"]
          //   )}`
          // );
          handleCreateDebitFromList(
            row,
            formConfig,
            setIsOverlayLoader,
            navigate,
          );
        } else if (["Edit Debit Note"].includes(value)) {
          navigate(
            `/operation/invoice-listing/create-debit/${encryptDataForURL(
              row["im_id"],
            )}` +
            "?status=" +
            encryptDataForURL("Edit"),
          );
        } else if (["Courier Details"].includes(value)) {
          navigate(
            `/operation/invoice-listing/create-invoice/${encryptDataForURL(
              row["im_id"],
            )}` +
            "?status=" +
            encryptDataForURL("Edit") +
            "&isCourier=" +
            encryptDataForURL(true),
          );
          setTimeout(() => {
            window.location.reload();
          }, 10);
        } else if (["Create Credit Note", "View Credit Note"].includes(value)) {
          navigate(
            `/operation/invoice-listing/create-invoice/${encryptDataForURL(
              row["im_id"],
            )}` +
            "?status=" +
            encryptDataForURL(
              !row?.im_credit_note_json?.im_credit_status ||
                ["Posted", "reject-2"].includes(
                  row?.im_credit_note_json?.im_credit_status,
                )
                ? "View"
                : "Edit",
            ) +
            "&isCourier=" +
            encryptDataForURL(true) +
            "&isCreditNote=" +
            encryptDataForURL(true) +
            "&isCreditNoteView=" +
            encryptDataForURL(["View Credit Note"].includes(value)),
          );
          setTimeout(() => {
            window.location.reload();
          }, 10);
        } else if (["Add new comment"].includes(value)) {
          setIsCustomPopup(true);
          setClickedRow(row);
        } else if (["History"].includes(value)) {
          const historyDetails = {
            object_id: `${row["im_id"]}`,
            model: model || "invoice",
            redirect: "/operation/invoice-listing",
            Breadcrumb: "Invoice List",
          };
          dispatch(historyData(historyDetails));
          navigate(
            `/module-history?id=${encryptDataForURL(row["im_id"])}&status=${encryptDataForURL("History")}`,
          );
          return;
        } else if (value === "Download Draft") {
          handleDownloadDraftInvoice(row["im_id"])
          setPopupIndex(-1);
        }
      } else {
        if (from === "subListTable") {
          if (
            ["configurationList", "commercialCertificate"].includes(
              subModuleType,
            )
          ) {
            if (value === "View" && subModuleType === "configurationList") {
              navigate(
                "/operation/operation-certificate/" +
                encryptDataForURL(row?.fk_jiid) +
                "/" +
                encryptDataForURL(row?.fk_jisid) +
                "?status=" +
                encryptDataForURL(row?.status) +
                "&RPCID=" +
                encryptDataForURL(row?.rpc_id) +
                "&OperationType=" +
                encryptDataForURL(OperationType) +
                "&opsCertiView=" +
                encryptDataForURL("view") +
                "&operationMode=" +
                encryptDataForURL(operationMode),
              );
            } else if (
              ["Edit Certi.", "Upload Custom Format", "Delete Custom Format"].includes(value) &&
              subModuleType === "commercialCertificate"
            ) {
              if (value === "Delete Custom Format") {
                await handleDeleteCustomFormatCertificate(row, getAllListingData, setIsOverlayLoader)
                return
              }
              if (["SU"].includes(user.role)) {
                // if (["Upload Custom Format"].includes(value)) {
                //   setPopupType("Upload")
                //   setUploadPopup(true)
                //   setFormData((prev)=>{
                //     return {
                //       ...prev,
                //       0:{
                //         ...prev[0],
                //         cc_is_custom_format_file:"Yes",
                //         cc_id:row.cc_id,
                //         is_custom_format_upload:true
                //       }
                //     }
                //   })
                // }
                // else{
                EditCertificate(["Upload Custom Format"].includes(value), '', 1);
                // }
                return;
              }
            } else if (
              value === "Edit Config." &&
              subModuleType === "commercialCertificate"
            ) {
              if (["SU"].includes(user.role)) {
                navigate(
                  "/operation/operation-certificate/" +
                  encryptDataForURL(row.fk_jiid) +
                  "/" +
                  encryptDataForURL(row["fk_jisid"]) +
                  "?status=" +
                  encryptDataForURL("completed") +
                  "&RPCID=" +
                  encryptDataForURL(row.fk_rpc_id) +
                  "&OperationType=" +
                  encryptDataForURL(row["activity_code"].toLowerCase()) +
                  "&operationMode=" +
                  encryptDataForURL(row["operationmode"]["ops_code"]),
                );
                setTimeout(() => {
                  window.location.reload();
                }, 10);
                return;
              }
            } else if (
              value === "History" &&
              subModuleType === "commercialCertificate"
            ) {
              const historyDetails = {
                object_id: `${row["cc_id"]}`,
                model: model || "commercialCertificate",
                redirect: "/operation/commercial-certificate-list",
                Breadcrumb: "Certificates",
              };
              dispatch(historyData(historyDetails));
              navigate(
                `/module-history?id=${encryptDataForURL(row["cc_id"])}&status=${encryptDataForURL("History")}`,
              );
              return;
            } else if (value.toLowerCase() === "delete") {
              setIsDelete(true);
              return;
            } else if (
              value === "View Config. Details" &&
              subModuleType === "commercialCertificate"
            ) {
              navigate(
                "/operation/operation-certificate/" +
                encryptDataForURL(row.fk_jiid) +
                "/" +
                encryptDataForURL(row["fk_jisid"]) +
                "?status=" +
                encryptDataForURL("completed") +
                "&RPCID=" +
                encryptDataForURL(row.fk_rpc_id) +
                "&OperationType=" +
                encryptDataForURL(row["activity_code"].toLowerCase()) +
                "&operationMode=" +
                encryptDataForURL(row["operationmode"]["ops_code"]) +
                "&opsCertiView=" +
                encryptDataForURL("view"),
              );
              return;
            } else if (
              value === "View Certi. Details" &&
              subModuleType === "commercialCertificate"
            ) {
              EditCertificate(1);
              return;
            }

            else if (
              value === "Change Logs" &&
              subModuleType === "commercialCertificate"
            ) {
              let historyDetails = {
                model: model,
                Breadcrumb: "Certificate Details",
                data: row.cc_audit_history,
                isLSMSActivity: getLMSOperationActivity().includes(
                  getActivityCode(row.activity_code).toLowerCase(),
                ),
                configData: row?.rpc_details?.rpc_audit_history,
                sampleData: row?.cert_config_audit_history,
                redirect: "/operation/commercial-certificate-list",
              };
              dispatch(ChangesLogDATA(historyDetails));
              navigate(`/su-history-logs`);
              return;
            }
            else if (value === "Request Cancellation" &&
              subModuleType === "commercialCertificate") {
              EditCertificate(1, 1);
              return;
            }
            else if (subModuleType === "commercialCertificate" && ["With OCR Certificate", "Certificate Download", "Download Custom Format"].includes(value)) {
              let isCustomFormat = false;
              if (!['SU'].includes(user?.role)) {
                if (!row.cc_is_external && row.cc_is_custom_format_file) {
                  isCustomFormat = true
                }
              }
              handleDownloadCertificateAfterPublish(row, value == "With OCR Certificate", value == "Download Custom Format" || isCustomFormat)
              return
            }
            else if (!['SU'].includes(user?.role) && !row.cc_is_external && row.cc_is_custom_format_file) {
              navigate(
                `/operation/commercial-certificate-list/commercial-certificate-preview/${encryptDataForURL(row?.fk_jisid)}/${encryptDataForURL(row.cc_id)}?status=${encryptDataForURL(
                  "View",
                )}&CCID=${encryptDataForURL(row.cc_id)}` +
                "&OperationType=" +
                encryptDataForURL(row?.activity_code) +
                "&isExternal=" +
                encryptDataForURL(1),
              );
              return;
            }
            else if (
              !getLMSOperationActivity().includes(
                getActivityCode(
                  row?.activity_master?.activity_code || row.activity_code,
                ).toLowerCase(),
              ) &&
              ![
                getVesselOperation("bulk_crg"),
                getStackOperations("ST_SV"),
                getRakeOperations("RK_SV"),
              ].includes(
                getActivityCode(
                  row?.activity_master?.activity_code || row.activity_code,
                ).toLowerCase(),
              )
            ) {
              if (row.cc_is_external) {
                navigate(
                  `/operation/commercial-certificate-list/commercial-certificate-preview/${encryptDataForURL(row?.fk_jisid)}/${encryptDataForURL(row.cc_id)}?status=${encryptDataForURL(
                    "View",
                  )}&CCID=${encryptDataForURL(row.cc_id)}` +
                  "&OperationType=" +
                  encryptDataForURL(row?.activity_code) +
                  "&isExternal=" +
                  encryptDataForURL(1),
                );
                return;
              } else if (row?.cc_is_physical) {
                navigate(
                  `/operation/commercial-certificate-list/commercial-certificate-preview/${encryptDataForURL(
                    row?.fk_jiid,
                  )}/${encryptDataForURL(row.cc_id)}?status=${encryptDataForURL(
                    "View",
                  )}&CCID=${encryptDataForURL(row.cc_id)}&OperationType=${encryptDataForURL(row.activity_code)}` +
                  "&isUseForPhysical=" +
                  encryptDataForURL(1),
                );
                return;
              }
              let payload = {
                ji_id: row?.fk_jiid,
                jis_id: row?.fk_jisid,
                tenant: 1,
              };
              // let OPSDSRes = await postDataFromApi(
              //   "/ops-vessel-ds/get/",
              //   payload
              // );
              let OPSDSRes = await getNonLMSDetailsById(
                getActivityCode(row.activity_code).toLowerCase(),
                payload,
              );
              if (OPSDSRes.status === 200) {
                navigate(
                  `/operation/commercial-certificate-list/commercial-certificate-preview/${encryptDataForURL(
                    OPSDSRes?.data?.data?.opsvd_id,
                  )}/${encryptDataForURL(row.cc_id)}?status=${encryptDataForURL(
                    "View",
                  )}&CCID=${encryptDataForURL(row.cc_id)}&OperationType=${encryptDataForURL(row.activity_code)}`,
                );
              }
            } else {
              if (row.cc_is_external) {
                navigate(
                  `/operation/commercial-certificate-list/commercial-certificate-preview/${encryptDataForURL(row?.fk_jisid)}/${encryptDataForURL(row.cc_id)}?status=${encryptDataForURL(
                    "View",
                  )}&CCID=${encryptDataForURL(row.cc_id)}` +
                  "&OperationType=" +
                  encryptDataForURL(row?.activity_code) +
                  "&isExternal=" +
                  encryptDataForURL(1),
                );
                return;
              } else if (row?.cc_is_physical) {
                navigate(
                  `/operation/commercial-certificate-list/commercial-certificate-preview/${encryptDataForURL(
                    row?.fk_jiid,
                  )}/${encryptDataForURL(row.cc_id)}?status=${encryptDataForURL(
                    "View",
                  )}&CCID=${encryptDataForURL(row.cc_id)}&OperationType=${encryptDataForURL(row.activity_code)}` +
                  "&isUseForPhysical=" +
                  encryptDataForURL(1),
                );
                return;
              }
              navigate(
                `/operation/commercial-certificate-list/commercial-certificate-preview/${encryptDataForURL(
                  row?.fk_jiid,
                )}/${encryptDataForURL(row.cc_id)}?status=${encryptDataForURL(
                  "View",
                )}&CCID=${encryptDataForURL(row.cc_id)}&OperationType=${encryptDataForURL(row.activity_code)}` +
                `&activityJIID=${encryptDataForURL(row.fk_jisid)}`,
              );
            }
          } else {
            if (
              getLMSOperationActivity().includes(
                getActivityCode(
                  row["activity_master"]["activity_code"],
                ).toLowerCase(),
              )
            ) {
              let opsNo = 2;
              if (
                getRakeCollectionActivity().includes(
                  getActivityCode(
                    row["activity_master"]["activity_code"],
                  ).toLowerCase(),
                )
              ) {
                opsNo = 7;
              } else if (
                getSampleCollectionActivity().includes(
                  getActivityCode(
                    row["activity_master"]["activity_code"],
                  ).toLowerCase(),
                )
              ) {
                opsNo = 6;
              }
              navigate(
                getOperationActivityUrl(operationMode) +
                encryptDataForURL(row["fk_jiid"]) +
                "/" +
                encryptDataForURL(row["activity_master"]["activity_code"]) +
                "?OperationType=" +
                encryptDataForURL(row["activity_master"]["activity_code"]) +
                "&operationId=" +
                encryptDataForURL(row["jis_id"]) +
                "&operationStepNo=" +
                encryptDataForURL(opsNo) +
                "&action=" +
                encryptDataForURL("opsView") +
                "&operationMode=" +
                encryptDataForURL(operationMode),
              );
            } else if (
              moduleType === "vesselOperation" &&
              formConfig?.listView?.subModuleType === "configurationList"
            ) {
              navigate(
                "/operation/vessel-ji-list/vessel-list/" +
                encryptDataForURL(row["fk_jiid"]) +
                "/" +
                encryptDataForURL(OperationType) +
                "?OperationType=" +
                encryptDataForURL(OperationType) +
                "&operationId=" +
                encryptDataForURL(row["jis_id"]) +
                "&useFor=" +
                encryptDataForURL("viewOnly") +
                "&action=" +
                encryptDataForURL("View"),
              );
            } else {
              navigate(
                getOperationActivityUrl(operationMode) +
                encryptDataForURL(formData[0]?.ji_id) +
                "/" +
                encryptDataForURL(row["activity_master"]["activity_code"]) +
                "?OperationType=" +
                encryptDataForURL(row["activity_master"]["activity_code"]) +
                "&operationId=" +
                encryptDataForURL(row["jis_id"]) +
                "&useFor=" +
                encryptDataForURL("viewOnly") +
                "&action=" +
                encryptDataForURL("View") +
                "&activityJIID=" +
                encryptDataForURL(row["fk_jiid"]),
              );
            }
          }
          setPopupIndex(-1);
        }
        if (value === "Delete") {
          setIsDelete(true);
          return;
        }
        if (subModuleType == "commercialCertificate" && value === "View") {

        }
        else if (subModuleType === "commercialCertificate" && ["With OCR Certificate", "Certificate Download", "Download Custom Format"].includes(value)) {
          let isCustomFormat = false;
          if (!['SU'].includes(user?.role)) {
            if (!row.cc_is_external && row.cc_is_custom_format_file) {
              isCustomFormat = true
            }
          }
          handleDownloadCertificateAfterPublish(row, value == "With OCR Certificate", value == "Download Custom Format" || isCustomFormat)
        }
        else if (value === "History") {
          const historyDetails = {
            recordNo: "Job Instruction No " + row.ji_reference_number,
            model: model,
            redirect: "/operation/jrfInstructionListing",
            Breadcrumb: "Job Instruction List",
          };

          dispatch(historyData(historyDetails));
          navigate(
            `/module-history?status=${encryptDataForURL(
              value,
            )}&id=${encryptDataForURL(row["ji_id"])}`,
          );

          setPopupIndex(-1);
        } else if (value === "Documents") {
          navigate(
            "/operation/JI-commercial-certificate-list/" +
            encryptDataForURL(row.ji_id),
          );
        } else if (value === "All Reports") {
          handleViewAllReports(row.ji_id);
        } else if (value === "Edit") {
          // localStorage.setItem('isMainScopeWork','');
          dispatch({
            type: "MAIN_SCOPE_WORK",
            isMainScopeWork: "",
          });
          navigate(
            `/operation/jrfInstructionListing/job-instruction/${encryptDataForURL(
              row["ji_id"],
            )}`,
          );
          setPopupIndex(-1);
        } else if (value === "Man Power") {
          navigate(
            `/operation/jrfInstructionListing/job-instruction/man-power/${encryptDataForURL(
              row["ji_id"],
            )}`,
          );
        }
        else if (value === "Request Cancellation") {
          let redirecturl = getOperationActivityListPageUrl(
            row["operation_type"]["operation_type_code"],
          );
          redirecturl = redirecturl.replace(/\/([^\/]*)$/, "-$1");
          navigate(
            redirecturl +
            "view" +
            "/" +
            encryptDataForURL(row["ji_id"]) +
            "?action=" +
            encryptDataForURL("View") +
            "&status=" +
            encryptDataForURL('cancelJI') +
            `&isFullDetails=${encryptDataForURL(1)}`,
          );
          return
        }
        else {
          if (["CP", "BH"].includes(user?.role)) {
            let redirectUrl = getOperationActivityUrl(
              row["operation_type"]["operation_type_name"],
            );
            navigate(
              redirectUrl +
              encryptDataForURL(row["ji_id"]) +
              "?action=" +
              encryptDataForURL("View"),
            );
          } else if (value === "Change Logs") {
            let historyDetails = null;
            if (["commercialCertificate"].includes(subModuleType)) {
              historyDetails = {
                model: model,
                Breadcrumb: "Certificate Details",
                data: row.cc_audit_history,
                isLSMSActivity: getLMSOperationActivity().includes(
                  getActivityCode(row.activity_code).toLowerCase(),
                ),
                configData: row?.rpc_details?.rpc_audit_history,
                sampleData: row?.cert_config_audit_history,
                redirect: "/operation/commercial-certificate-list",
              };
            } else {
              historyDetails = {
                model: model,
                Breadcrumb: "Jobinstruction List",
                data: row.ji_audit_history,
                redirect: "/operation/jrfInstructionListing",
              };
            }

            dispatch(ChangesLogDATA(historyDetails));
            navigate(`/su-history-logs`);
            return;
          } else {
            let redirecturl = getOperationActivityListPageUrl(
              row["operation_type"]["operation_type_name"],
            );
            redirecturl = redirecturl.replace(/\/([^\/]*)$/, "-$1");
            navigate(
              `${redirecturl}view/${encryptDataForURL(
                row["ji_id"],
              )}?action=${encryptDataForURL("View")}&useFor=${encryptDataForURL(
                "viewOnly",
              )}&isFullDetails=${encryptDataForURL(1)}`,
            );
            setPopupIndex(-1);
          }
        }
      }
    } else if (moduleType === "clientInvoices") {
      if (["View"].includes(value)) {
        navigate(
          `/operation/invoice-listing/create-invoice/${encryptDataForURL(
            row["im_id"],
          )}` +
          "?status=" +
          encryptDataForURL(value),
        );
        setPopupIndex(-1);
      } else if (["View Invoice"].includes(value)) {
        navigate(
          `/operation/invoice-listing/invoice-preview/${encryptDataForURL(
            row["im_id"],
          )}/${encryptDataForURL(row["im_invoiceurl"])}/${encryptDataForURL(
            row["im_invoicenumber"],
          )}?invoice_date=${encryptDataForURL(row["im_invoice_date"])}`,
        );
      }
    } else if (["truckOperation", "vesselOperation"].includes(moduleType)) {
      if (value === "Delete") {
        setIsDelete(true);
      } else if (value === "Man Power") {
        navigate(
          `/operation/jrfInstructionListing/job-instruction/man-power/${encryptDataForURL(
            row["fk_jiid"],
          )}/${encryptDataForURL(
            row["fk_activitymasterid"],
          )}?activityName=${encryptDataForURL(row?.activity_master?.activity_name)}&operationMode=${encryptDataForURL(operationMode)}`,
        );
      } else {
        if (from === "subListTable") {
          if (
            ["configurationList", "commercialCertificate"].includes(
              subModuleType,
            )
          ) {
            if (value === "View" && subModuleType === "configurationList") {
              navigate(
                "/operation/operation-certificate/" +
                encryptDataForURL(row?.fk_jiid) +
                "/" +
                encryptDataForURL(row?.fk_jisid) +
                "?status=" +
                encryptDataForURL(row?.status) +
                "&RPCID=" +
                encryptDataForURL(row?.rpc_id) +
                "&OperationType=" +
                encryptDataForURL(OperationType) +
                "&opsCertiView=" +
                encryptDataForURL("view") +
                "&operationMode=" +
                encryptDataForURL(operationMode),
              );
            } else if (
              !getLMSOperationActivity().includes(
                getActivityCode(
                  row?.activity_master?.activity_code || row.activity_code,
                ).toLowerCase(),
              ) &&
              ![
                getVesselOperation("bulk_crg"),
                getStackOperations("ST_SV"),
                getRakeOperations("RK_SV"),
              ].includes(
                getActivityCode(
                  row?.activity_master?.activity_code || row.activity_code,
                ).toLowerCase(),
              )
            ) {
              let payload = {
                ji_id: row?.fk_jiid,
                jis_id: row?.fk_jisid,
                tenant: 1,
              };
              // let OPSDSRes = await postDataFromApi(
              //   "/ops-vessel-ds/get/",
              //   payload
              // );
              let OPSDSRes = await getNonLMSDetailsById(
                getActivityCode(row.activity_code).toLowerCase(),
                payload,
              );
              if (OPSDSRes.status === 200) {
                navigate(
                  `/operation/commercial-certificate-list/commercial-certificate-preview/${encryptDataForURL(
                    OPSDSRes?.data?.data?.opsvd_id,
                  )}/${encryptDataForURL(row.cc_id)}?status=${encryptDataForURL(
                    "View",
                  )}&CCID=${encryptDataForURL(row.cc_id)}&OperationType=${encryptDataForURL(row.activity_code)}`,
                );
              }
            } else {
              navigate(
                `/operation/commercial-certificate-list/commercial-certificate-preview/${encryptDataForURL(
                  row?.fk_jiid,
                )}/${encryptDataForURL(row.cc_id)}?status=${encryptDataForURL(
                  "View",
                )}&CCID=${encryptDataForURL(row.cc_id)}&OperationType=${encryptDataForURL(row.activity_code)}`,
              );
            }
          } else {
            if (
              getLMSOperationActivity().includes(
                getActivityCode(
                  row["activity_master"]["activity_code"],
                ).toLowerCase(),
              )
            ) {
              let opsNo = 2;
              if (
                getRakeCollectionActivity().includes(
                  getActivityCode(
                    row["activity_master"]["activity_code"],
                  ).toLowerCase(),
                )
              ) {
                opsNo = 7;
              } else if (
                getSampleCollectionActivity().includes(
                  getActivityCode(
                    row["activity_master"]["activity_code"],
                  ).toLowerCase(),
                )
              ) {
                opsNo = 6;
              }
              navigate(
                getOperationActivityUrl(operationMode) +
                encryptDataForURL(row["fk_jiid"]) +
                "/" +
                encryptDataForURL(row["activity_master"]["activity_code"]) +
                "?OperationType=" +
                encryptDataForURL(row["activity_master"]["activity_code"]) +
                "&operationId=" +
                encryptDataForURL(row["jis_id"]) +
                "&operationStepNo=" +
                encryptDataForURL(opsNo) +
                "&action=" +
                encryptDataForURL("opsView") +
                "&operationMode=" +
                encryptDataForURL(operationMode),
              );
            } else if (
              moduleType === "vesselOperation" &&
              formConfig?.listView?.subModuleType === "configurationList"
            ) {
              navigate(
                "/operation/vessel-ji-list/vessel-list/" +
                encryptDataForURL(row["fk_jiid"]) +
                "/" +
                encryptDataForURL(OperationType) +
                "?OperationType=" +
                encryptDataForURL(OperationType) +
                "&operationId=" +
                encryptDataForURL(row["jis_id"]) +
                "&useFor=" +
                encryptDataForURL("viewOnly") +
                "&action=" +
                encryptDataForURL("View"),
              );
            } else {
              if (!formData?.[0]?.["operation_type"]?.operation_is_system_generated || row["activity_master"]?.am_is_system_generated) {
                // console.log("@@@",row?.cc_id,row?.activity_master?.activity_code,row)
                navigate(
                  `/operation/commercial-certificate-list/commercial-certificate-preview/${encryptDataForURL(row?.jis_id)}/${encryptDataForURL(row.cc_id)}?status=${encryptDataForURL(
                    "View",
                  )}&CCID=${encryptDataForURL(row.cc_id)}` +
                  "&OperationType=" +
                  encryptDataForURL(row?.activity_master?.activity_code) +
                  "&isExternal=" +
                  encryptDataForURL(1),
                );
              }
              else {
                navigate(
                  getOperationActivityUrl(operationMode) +
                  encryptDataForURL(formData[0]?.ji_id) +
                  "/" +
                  encryptDataForURL(row["activity_master"]["activity_code"]) +
                  "?OperationType=" +
                  encryptDataForURL(row["activity_master"]["activity_code"]) +
                  "&operationId=" +
                  encryptDataForURL(row["jis_id"]) +
                  "&useFor=" +
                  encryptDataForURL("viewOnly") +
                  "&action=" +
                  encryptDataForURL("View") +
                  "&operationMode=" +
                  encryptDataForURL(operationMode) +
                  "&activityJIID=" +
                  encryptDataForURL(row["fk_jiid"]),
                );
              }
            }
          }
          setPopupIndex(-1);
        }
      }
    } else if (
      ["JICommercialCertificateList", ...uploadExtraModules].includes(
        moduleType,
      )
    ) {
      if (value === "Delete") {
        setIsDelete(true);
      } else {
        setPopupType(value);
      }
    } else if (moduleType === "TPIMain") {
      if (value === "View") {
        navigate(
          `/operation/vessel-ji-list/other-tpi/${encryptDataForURL(
            row["fk_jiid"],
          )}/${encryptDataForURL("otherTPI")}/${encryptDataForURL(
            row["fk_jis_id"],
          )}/${encryptDataForURL(
            row["tpi_id"],
          )}?OperationType=${encryptDataForURL(
            row["activity_code"],
          )}&operationId=${encryptDataForURL(
            row["fk_jis_id"],
          )}&action=${encryptDataForURL("View")}`,
        );
      } else if (value === "History") {
        const historyDetails = {
          object_id: `${row["tpi_id"]}`,
          model: model || "tpimain",
          redirect: "/operation/other-tpi",
          Breadcrumb: "External Results Data",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL(
            value,
          )}&id=${encryptDataForURL(row["tpi_id"])}`,
        );

        setPopupIndex(-1);
      }
      else if (value === "Edit") {
        navigate(
          `/operation/vessel-ji-list/other-tpi/${encryptDataForURL(
            row["fk_jiid"],
          )}/${encryptDataForURL("otherTPI")}/${encryptDataForURL(
            row["fk_jis_id"],
          )}/${encryptDataForURL(
            row["tpi_id"],
          )}?OperationType=${encryptDataForURL(
            row["activity_code"],
          )}&operationId=${encryptDataForURL(row["fk_jis_id"])}`,
        );
      }
    } else if (moduleType === "consortiumorder") {
      if (value === "Delete") {
        setIsDelete(true);
      } else if (value === "Edit") {
        navigate(
          `/operation/consortiums-list/consortium/${encryptDataForURL(
            row["co_id"],
          )}`,
        );
        setPopupIndex(-1);
      } else if (value === "History") {
        const historyDetails = {
          object_id: `${row["co_id"]}`,
          model: model || "consortiumorder",
          redirect: "/operation/consortiums-list",
          Breadcrumb: "Consortium List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?id=${encryptDataForURL(row["co_id"])}&status=${encryptDataForURL("History")}`,
        );
      } else {
        navigate(
          `/operation/consortiums-list/consortium/${encryptDataForURL(
            row["co_id"],
          )}?action=${encryptDataForURL("View")}`,
        );
      }
    } else if (moduleType === "jobCosting") {
      if (value === "View") {
        navigate(
          `/audit/job-costing-edit/${encryptDataForURL(row["jc_id"])}?status=${encryptDataForURL("View")}`,
        );
      }
      else if (value === "View Invoice") {
        navigate(
          `/operation/invoice-listing/create-invoice/${encryptDataForURL(
            row["fk_im_id"]?.im_id,
          )}` +
          "?status=" +
          encryptDataForURL('View'),
        );
        setPopupIndex(-1);
      } else if (value === "View Certificates") {
        navigate(
          `/audit/job-costing-list/commercial-certificate-list/${encryptDataForURL(
            row["fk_im_id"]?.im_id,
          )}` +
          "?isNoPermission=" +
          encryptDataForURL('true'),
        );
        setPopupIndex(-1);
      } else if (value === "History") {
        const historyDetails = {
          object_id: `${row["jc_id"]}`,
          model: model,
          redirect: "/audit/job-costing-list",
          Breadcrumb: "Job Costing List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?id=${encryptDataForURL(row["jc_id"])}&status=${encryptDataForURL("History")}`,
        );
      }
      else if (value == "Documents") {
        navigate(
          "/audit/job-costing-document-list/" +
          encryptDataForURL(row["jc_id"]) +
          "?fd_name=" +
          encryptDataForURL(row["jc_id"]),
        );
      }
    } else if (moduleType === "auditBranchExpenses") {
      if (value === "View") {
        navigate(
          `/audit/auditBranchExpenseForm/${encryptDataForURL(row["id"])}?status=${encryptDataForURL("View")}`,
        );
      } else if (value === "History") {
        const historyDetails = {
          object_id: `${row["id"]}`,
          model: model,
          redirect: "/audit/branch-expense-list",
          Breadcrumb: "Expenses List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL("History")}&id=${encryptDataForURL(row["id"])}`,
        );
      }
    } else if (moduleType === "auditOutstanding") {
      if (value === "View") {
        navigate(
          `/audit/auditOutstandingForm/${encryptDataForURL(row["id"])}?status=${encryptDataForURL("View")}`,
        );
      } else if (value === "History") {
        const historyDetails = {
          object_id: `${row["id"]}`,
          model: model,
          redirect: "/audit/outstanding-list",
          Breadcrumb: "Outstanding List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL("History")}&id=${encryptDataForURL(row["id"])}`,
        );
      }
    } else if (moduleType === "auditSalesRegister") {
      if (value === "View") {
        navigate(
          `/audit/auditSalesRegisterForm/${encryptDataForURL(row["id"])}?status=${encryptDataForURL("View")}`,
        );
      } else if (value === "History") {
        const historyDetails = {
          object_id: `${row["id"]}`,
          model: model,
          redirect: "/audit/sales-register-list",
          Breadcrumb: "Sales List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL("History")}&id=${encryptDataForURL(row["id"])}`,
        );
      }
    }
    else if (moduleType === "auditBranchSales") {
      if (value === "View") {
        navigate(
          `/audit/BranchSalesForm/${encryptDataForURL(row["id"])}?status=${encryptDataForURL("View")}`,
        );
      }
    }
    else if (moduleType === "purchaseReq") {
      if (value === "View") {
        navigate(
          `/PurchRequistion/PurchaseRequistionForm/${encryptDataForURL(row["req_no"])}?status=${encryptDataForURL("View")}`,
        );
      } else if (value === "History") {
        const historyDetails = {
          object_id: `${row["req_id"]}`,
          model: model || "purchaserequisition",
          redirect: "/PurchRequistion",
          Breadcrumb: "Purchase Requistion List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL("History")}&id=${encryptDataForURL(row["req_id"])}`,
        );
      } else if (value === "Download") {
        handleDownloadPR(row["req_id"]);
      } else if (value === "Delete") {
        setIsDelete(true);
      } else if (value == "Documents") {
        navigate(
          "/PurchRequistion/purchreqDocumentlist/" +
          encryptDataForURL(row["req_id"]) +
          "?fd_name=" +
          encryptDataForURL(row["req_no"]),
        );
      } else if (value === "Edit") {
        navigate(
          `/PurchRequistion/PurchaseRequistionForm/${encryptDataForURL(
            row["req_no"],
          )}?useFor=${encryptDataForURL("Edit")}`,
        );
      } else if (value === "PO Create") {
        navigate(
          `/PurchRequistion/PurchaseRequistionForm/${encryptDataForURL(
            row["req_no"],
          )}?useFor=${encryptDataForURL("CreatePO")}`,
        );
      } else if (value === "View PO List") {
        navigate(
          `/purchase?req_no=${encryptDataForURL(
            row["req_no"],
          )}`,
        );
      }
    } else if (moduleType === "purchase") {
      if (value === "View") {
        navigate(
          `/purchase/purchaseForm/${encryptDataForURL(row["po_id"])}?status=${encryptDataForURL("View")}`,
        );
      } else if (value === "Download") {
        handleDownloadPO(row["po_id"], row["po_number"]);
      } else if (value === "PO Items Download") {
        handleDownloadPOItemsExport(row["po_id"], row["po_number"]);
      } else if (value === "History") {
        const historyDetails = {
          object_id: `${row["po_id"]}`,
          model: model || "purchaseorder",
          redirect: "/purchase",
          Breadcrumb: "Purchase Order List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL("History")}&id=${encryptDataForURL(row["po_id"])}`,
        );
      } else if (value === "Delete") {
        setIsDelete(true);
      } else if (value === "Documents") {
        navigate(
          "/purchaseorderList/purchaseorder-document-list/" +
          encryptDataForURL(row.po_id) +
          "?fd_name=" +
          encryptDataForURL(row["po_number"]),
        );
      } else if (value === "PR Documents") {
        navigate(
          "/PurchRequistion/purchreqDocumentlist/" +
          encryptDataForURL(row["fk_req_id"]) +
          "?fd_name=" +
          encryptDataForURL(row?.["requisition_details"]?.["req_no"]),
        );
      } else if (value === "PR Documents") {
        navigate(
          "/PurchRequistion/purchreqDocumentlist/" +
          encryptDataForURL(row["fk_req_id"]) +
          "?fd_name=" +
          encryptDataForURL(row?.["requisition_details"]?.["req_no"]),
        );
      } else if (value === "PR Download") {
        handleDownloadPR(row["fk_req_id"]);
        return
      } else if (value === "Insurance Details") {
        navigate(
          `/purchase/purchaseForm/${encryptDataForURL(row["po_id"])}?status=${encryptDataForURL("View")}` +
          "&isInsurance=" +
          encryptDataForURL(true),
        );
      } else if (value === "Vendor Rating Details") {
        navigate(
          `/purchase/purchaseForm/${encryptDataForURL(row["po_id"])}?status=${encryptDataForURL("View")}` +
          "&isVendorField=" +
          encryptDataForURL(true),
        );
      } else if (value === "Edit PO") {
        navigate(`/purchase/purchaseForm/${encryptDataForURL(row["po_id"])}`);
      } else if (value === "Reminder for Approval") {
        try {
          setIsOverlayLoader(true);
          let payload = {
            po_id: row?.po_id,
          };
          let res = await postDataFromApi(purchaseOrderRemindApi, payload);
          if (res?.data?.status === 200) {
            toast.success(res.data.message, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            getAllListingData();
          } else {
            toast.error(res.message, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        } finally {
          setIsOverlayLoader(false);
          setPopupIndex(-1);
        }
      } else if (value === "Reminder Email History") {
        const historyDetails = {
          model: model,
          Breadcrumb: "Purchase Reminder Email History",
          data: row.po_reminder_history,
          isRemiderEmail: true,
          redirect: "/purchase",
        };

        dispatch(ChangesLogDATA(historyDetails));
        navigate(`/su-history-logs`);
      } else if (value === "Send Email") {
        try {
          setIsOverlayLoader(true);
          let payload = {
            po_id: row?.po_id,
          };
          let res = await postDataFromApi(POVendorMailApi, payload);
          if (res?.data?.status === 200) {
            toast.success(res.data.message, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            getAllListingData();
          } else {
            toast.error(res.message, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        } finally {
          setIsOverlayLoader(false);
          setPopupIndex(-1);
        }
      }
      else if (value === "Change Logs") {
        const historyDetails = {
          model: model,
          Breadcrumb: "Purchase Order",
          data: row.po_audit_history,
          redirect: "/purchase",
        };
        dispatch(ChangesLogDATA(historyDetails));
        navigate(`/su-history-logs`);
      }
    } else if (moduleType === "poDashboard") {
      if (value === "View PR") {
        navigate(
          `/PurchRequistion/PurchaseRequistionForm/${encryptDataForURL(row["pr_no"])}?status=${encryptDataForURL("View")}`
        );
      }
      else if (value === "View PO") {
        navigate(
          `/purchase/purchaseForm/${encryptDataForURL(row["po_id"])}?status=${encryptDataForURL("View")}`,
        );
      }
    } else if (moduleType === "calibration") {
      if (value === "View") {
        if (row.fk_itemmaster) {
          navigate(
            `/itemlist/item/${encryptDataForURL(row["fk_itemmaster"])}?status=${encryptDataForURL("View")}`,
          );
        } else {
          navigate(
            `/calibrationList/calibrationForm/${encryptDataForURL(row["calib_id"])}?status=${encryptDataForURL("View")}`,
          );
        }
      } else if (value === "History") {
        const historyDetails = {
          object_id: `${row["calib_id"]}`,
          model: model || "calibration",
          redirect: "/calibrationList",
          Breadcrumb: "Calibration List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL("History")}&id=${encryptDataForURL(row["calib_id"])}`,
        );
      } else if (value === "Edit") {
        navigate(
          `/calibrationList/calibrationForm/${encryptDataForURL(row["calib_id"])}?status=${encryptDataForURL("Edit")}`,
        );
      } else if (value === "Delete") {
        setIsDelete(true);
      }
    } else if (moduleType === "amc") {
      if (value === "View") {
        if (row.fk_itemmaster) {
          navigate(
            `/itemlist/item/${encryptDataForURL(row["fk_itemmaster"])}?status=${encryptDataForURL("View")}`,
          );
        } else {
          navigate(
            `/AMCList/AMCForm/${encryptDataForURL(row["amc_id"])}?status=${encryptDataForURL("View")}`,
          );
        }
      } else if (value === "History") {
        const historyDetails = {
          object_id: `${row["amc_id"]}`,
          model: model || "amc",
          redirect: "/AMCList",
          Breadcrumb: "AMC List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL("History")}&id=${encryptDataForURL(row["amc_id"])}`,
        );
      }
      // else if (value === "Edit") {
      //   navigate(
      //     `amcForm/${encryptDataForURL(row["amc_id"])}?status=${encryptDataForURL("Edit")}`,
      //   );
      // }
      else if (value === "Delete") {
        setIsDelete(true);
      }
    }
    else if (moduleType === "tranferstocks") {
      if (value === "View") {
        navigate(
          `/transfer-stocks/form/${encryptDataForURL(row["st_transfer_id"])}?status=${encryptDataForURL("View")}`,
        );

      } else if (value === "Edit") {
        navigate(
          `/transfer-stocks/form/${encryptDataForURL(row["st_transfer_id"])}?status=${encryptDataForURL("Edit")}`,
        );
      }
      else if (value === "Delete") {
        setIsDelete(true);
      }
      if (value === "Documents") {
        navigate(
          "/transfer-stocks/transfer-stocks-document-list/" +
          encryptDataForURL(row.st_transfer_id),
        );

      }
    }
    else if (moduleType === "supplier") {
      if (value === "View") {
        navigate(
          `/supplierList/supplierForm/${encryptDataForURL(row["sup_id"])}?status=${encryptDataForURL("View")}`,
        );
      } else if (value === "Delete") {
        setIsDelete(true);
      } else if (value === "History") {
        const historyDetails = {
          object_id: `${row["sup_id"]}`,
          model: model || "supplier",
          redirect: "/supplierList",
          Breadcrumb: "Supplier List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL("History")}&id=${encryptDataForURL(row["sup_id"])}`,
        );
      }
    } else if (moduleType === "tender") {
      if (value === "View") {
        navigate(
          `/tenderList/tenderForm/${encryptDataForURL(row["tender_id"])}?status=${encryptDataForURL("View")}`,
        );
      } else if (value === "Edit") {
        navigate(
          `/tenderList/tenderForm/${encryptDataForURL(row["tender_id"])}?status=${encryptDataForURL("Change")}`,
        );
      } else if (value === "Delete") {
        setIsDelete(true);
      } else if (value === "Documents") {
        navigate(
          "/tenderList/tender-document-list/" +
          encryptDataForURL(row.tender_id),
        );
      }
    } else if (moduleType === "stocks") {
      if (value === "View") {
        navigate(
          `/chemicalStocks/chemicalStocksForm/${encryptDataForURL(row["chemist_stock_id"])}?status=${encryptDataForURL("View")}`,
        );
      } else if (value === "Delete") {
        setIsDelete(true);
      } else if (value === "Edit Callibration") {
        navigate(
          `/calibrationList/calibrationForm/` +
          encryptDataForURL(row?.fk_stock_calibration_id),
        );
      }
    } else if (moduleType === "incentives") {
      if (value === "View") {
        navigate(
          `/incentivesList/incentivesForm/${encryptDataForURL(row["incentive_id"])}?status=${encryptDataForURL("View")}`,
        );
      } else if (value === "Delete") {
        setIsDelete(true);
      }
    } else if (moduleType === "purchaseItems") {
      if (value === "View") {
        navigate(
          `/itemlist/item/${encryptDataForURL(row["item_id"])}?status=${encryptDataForURL("View")}`,
        );
      } else if (value === "Edit") {
        navigate(
          `/itemlist/item/${encryptDataForURL(row["item_id"])}?action=${encryptDataForURL("Change")}`,
        );
      } else if (value === "Documents") {
        navigate(
          `/itemlist/item-document-list/${encryptDataForURL(row["item_id"])}` +
          "?fd_name=" +
          encryptDataForURL(row["item_id"]),
        );
      } else if (value === "Delete") {
        setIsDelete(true);
      } else if (value === "Edit Callibration") {
        navigate(
          `/calibrationList/calibrationForm/` +
          encryptDataForURL(row?.fk_item_calibration_id),
        );
      }
    } else if (moduleType === "branchmasterList") {
      if (value === "View") {
        navigate(
          `/branchForm/${encryptDataForURL(row["br_id"])}?status=${encryptDataForURL("View")}`,
        );
      } else if (value === "Edit") {
        navigate(
          `/branchForm/${encryptDataForURL(row["br_id"])}?action=${encryptDataForURL("Change")}`,
        );
      } else if (value === "Delete") {
        setIsDelete(true);
      }
    } else if (moduleType === "departmentmasterList") {
      if (value === "View") {
        navigate(
          `/departmentForm/${encryptDataForURL(row["dept_id"])}?status=${encryptDataForURL("View")}`,
        );
      } else if (value === "Edit") {
        navigate(
          `/departmentForm/${encryptDataForURL(row["dept_id"])}?action=${encryptDataForURL("Change")}`,
        );
      } else if (value === "Delete") {
        setIsDelete(true);
      }
    } else if (moduleType === "category") {
      if (value === "View") {
        navigate(
          `/categorylist/categoryForm/${encryptDataForURL(row["category_id"])}?status=${encryptDataForURL("View")}`,
        );
      } else if (value === "Edit") {
        navigate(
          `/categorylist/categoryForm/${encryptDataForURL(row["category_id"])}?action=${encryptDataForURL("Change")}`,
        );
      } else if (value === "Delete") {
        setIsDelete(true);
      }
    }
    else if (moduleType === "lab_parameters") {
      if (value === "View") {
        navigate(
          `/operation/parameters/edit/${encryptDataForURL(row["lp_id"])}?status=${encryptDataForURL("View")}`,
        );
      } else if (value === "Edit") {
        navigate(
          `/operation/parameters/edit/${encryptDataForURL(row["lp_id"])}?action=${encryptDataForURL("Change")}`,
        );
      } else if (value === "Delete") {
        setIsDelete(true);
      }
    } else if (moduleType === "userMaster") {
      if (value === "View") {
        navigate(
          `/users/user-form/${encryptDataForURL(row["usr_id"])}?status=${encryptDataForURL("View")}`,
        );
      } else if (value === "Edit") {
        navigate(
          `/users/user-form/${encryptDataForURL(row["usr_id"])}?action=${encryptDataForURL("Change")}`,
        );
      }
    } else if (moduleType === "ClientWisePayment") {
      if (["Add New Remark"].includes(value)) {
        setIsCustomPopup(true);
        setClickedRow(row);
      } else if (["View"].includes(value)) {
        const historyDetails = {
          model: model,
          Breadcrumb: "Outstanding Remarks",
          data: row.old_remarks,
          isRemiderEmail: true,
          redirect: "/collections/client-payments",
        };

        dispatch(ChangesLogDATA(historyDetails));
        navigate(`/collection/outstanding-remark`);
      }
    } else if (moduleType === "feedback") {
      if (value === "View") {
        navigate(
          `/feedbackListList/feedbackListForm/${encryptDataForURL(row["feedback_id"])}?status=${encryptDataForURL("View")}`,
        );
      }
    } else if (moduleType === "ClientDetails") {

      navigate(
        `/collections/client-list/${encryptDataForURL(row["cust_id"])}` +
        "?action=" +
        encryptDataForURL(value),
        setPopupIndex(-1)
      );

      ;
    } else if (moduleType === "OnAccountDetails") {
      if (value === "Documents") {
        navigate(
          "/collections/on-accounts-document-list/" +
          encryptDataForURL(row["ioa_id"]) +
          "?fd_name=" +
          encryptDataForURL(row["ioa_id"]),
        );
      }
      else {
        navigate(
          `/collections/on-accounts/${encryptDataForURL(row["ioa_id"])}` +
          "?action=" +
          encryptDataForURL(value),
        );
        setPopupIndex(-1);
      }
    } else if (moduleType === "creditNoteModule") {
      if (value === "Delete") {
        setIsDelete(true);
      } else if (value === "Documents") {
        navigate(
          "/creditNoteList/creditNote-document-list/" +
          encryptDataForURL(row["cn_id"]) +
          "?fd_name=" +
          encryptDataForURL(row["cn_credit_note_no"]),
        );
      } else if (value === "View") {
        navigate(
          `/collections/credit-notes/credit-form/${encryptDataForURL(
            row["cn_id"],
          )}?action=${encryptDataForURL("View")}`,
        );
      } else if (value === "Remarks") {
        const historyDetails = {
          model: model,
          Breadcrumb: "Remarks",
          data: row.credit_note_remarks,
          isRemiderEmail: true,
          redirect: "/collections/credit-notes",
        };

        dispatch(ChangesLogDATA(historyDetails));
        navigate(`/collections/credit-notes/remarks`);
      } else if (value === "History") {
        const historyDetails = {
          object_id: `${row["cn_id"]}`,
          model: "creditnote",
          redirect: "/collections/credit-notes",
          Breadcrumb: "Credit Note List",
        };
        dispatch(historyData(historyDetails));
        navigate(
          `/module-history?status=${encryptDataForURL("History")}&id=${encryptDataForURL(row["cn_id"])}`,
        );
      }
      else if (value === "Edit") {
        navigate(
          `/collections/credit-notes/credit-form/${encryptDataForURL(
            row["cn_id"],
          )}?action=${encryptDataForURL("Edit")}`,
        );
      }
    }
    else if (moduleType === "vendorRating") {
      const historyDetails = {
        data: row
      };

      dispatch(VendorRatingDetails(historyDetails));
      navigate("/vendor-rating-list/view-details")
    }
  };

  const handleDeleteData = async () => {
    if (moduleType === "sampleinward") {
      handleSimpleInwardDeleteData();
      return;
    } else if (moduleType === "testmemomain") {
      handleTestMemoDeleteData();
      return;
    } else if (moduleType === "allotment") {
      handleAllotmentDelete();
      return;
    } else if (moduleType === "sampleverification") {
      handleSampleVerificationDelete();
      return;
    } else if (moduleType === "sfm") {
      handleSFMDelete();
      return;
    } else if (moduleType === "internalcertificate") {
      handleinternalcertificateDelete();
      return;
    } else if (
      moduleType === "jobinstruction" ||
      moduleType === "jioperationjsonb"
    ) {
      if (subModuleType == "commercialCertificate") {
        handleCommercialCertDelete(
          row.cc_id,
          setIsDelete,
          getAllListingData,
          setPopupIndex,
          row,
        );
      } else {
        handleJobInstructionDelete(
          row.ji_id,
          setIsDelete,
          getAllListingData,
          setPopupIndex,
        );
      }
      return;
    } else if (moduleType === "vesselOperation") {
      handleVesselOperationDelete(
        row,
        setIsDelete,
        getAllListingData,
        setPopupIndex,
      );
      return;
    } else if (
      ["JICommercialCertificateList", ...uploadExtraModules].includes(
        moduleType,
      )
    ) {
      handleDocumentDelete(row, setIsDelete, getAllListingData, setPopupIndex);
      return;
    } else if (moduleType === "consortiumorder") {
      handleConsortiumDelete(
        row,
        setIsDelete,
        getAllListingData,
        setPopupIndex,
      );
      return;
    } else if (moduleType === "supplier") {
      handleSupplierDelete(row, setIsDelete, getAllListingData, setPopupIndex);
    } else if (moduleType === "branchmasterList") {
      handleBranchMasterDelete(
        row,
        setIsDelete,
        getAllListingData,
        setPopupIndex,
      );
    } else if (moduleType === "departmentmasterList") {
      handleDepartmentDelete(
        row,
        setIsDelete,
        getAllListingData,
        setPopupIndex,
      );
    } else if (moduleType === "purchaseReq") {
      handlePurchaseReqDelete(
        row["req_no"],
        setIsDelete,
        getAllListingData,
        setPopupIndex,
      );
    } else if (moduleType === "purchase") {
      handlePurchaseOrderDelete(
        row["po_id"],
        setIsDelete,
        getAllListingData,
        setPopupIndex,
      );
    } else if (moduleType === "calibration") {
      handleCalibrationDelete(
        row["calib_id"],
        setIsDelete,
        getAllListingData,
        setPopupIndex,
      );
    } else if (moduleType === "amc") {
      handleAMCDelete(
        row["amc_id"],
        setIsDelete,
        getAllListingData,
        setPopupIndex,
      );
    }
    else if (moduleType === "tranferstocks") {
      handleTransferStocksDelete(
        row["st_transfer_id"],
        setIsDelete,
        getAllListingData,
        setPopupIndex,
      );
    }
    else if (moduleType === "purchaseItems") {
      handlePurchaseItemDelete(
        row["item_id"],
        setIsDelete,
        getAllListingData,
        setPopupIndex,
      );
    } else if (moduleType === "category") {
      handleCategoryDelete(
        row["category_id"],
        setIsDelete,
        getAllListingData,
        setPopupIndex,
      );
    }
    else if (moduleType === "lab_parameters") {
      handleLabParamDelete(
        row["lp_id"],
        setIsDelete,
        getAllListingData,
        setPopupIndex,
      );
    } else if (moduleType === "tender") {
      handleTenderDelete(
        row["tender_id"],
        setIsDelete,
        getAllListingData,
        setPopupIndex,
      );
    } else if (moduleType === "stocks") {
      handleChemicalStocksDelete(
        row["chemist_stock_id"],
        setIsDelete,
        getAllListingData,
        setPopupIndex,
      );
    } else if (moduleType === "incentives") {
      handleIncentiveDelete(
        row["incentive_id"],
        setIsDelete,
        getAllListingData,
        setPopupIndex,
      );
    } else if (moduleType === "creditNoteModule") {
      handleCreditNoteDelete(
        row["cn_id"],
        setIsDelete,
        getAllListingData,
        setPopupIndex,
      );
    } else {
      let deleteBody = {
        jrf_id: id,
      };
      let res = await deleteDataFromApi(JRFDeleteApi, deleteBody);
      if (res?.data?.status === 200) {
        toast.success(res.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        toast.error(res.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
      setIsDelete(false);
      setPopupIndex(-1);
      getAllListingData();
    }
  };
  const handleSimpleInwardDeleteData = async () => {
    let res;
    if (row["status"] == "rejected") {
      let MainData = {
        jrf_id: id,
        jrf_data: {
          jrf_status: "cancelled",
        },
      };
      res = await putDataFromApi(formConfig.apiEndpoints.update, MainData);
    } else {
      let deleteBody = {
        smpl_inwrd_id: sampleInwardFormId,
      };
      res = await deleteDataFromApi(sampleInwardDetailsDeleteAPI, deleteBody);
    }
    if (res?.data?.status === 200) {
      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    setIsDelete(false);
    setPopupIndex(-1);
    getAllListingData();
  };
  const handleTestMemoDeleteData = async () => {
    let deleteBody = {
      test_memo_id: row.tm_id,
    };
    let res = await deleteDataFromApi(testMemoDeleteApi, deleteBody);

    if (res?.data?.status === 200) {
      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    setIsDelete(false);
    setPopupIndex(-1);
    getAllListingData();
  };
  const handleAllotmentDelete = async () => {
    let deleteBody = {
      sa_id: row.sa_id,
    };
    let res = await deleteDataFromApi(allotmentDeleteApi, deleteBody);

    if (res?.data?.status === 200) {
      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    setIsDelete(false);
    setPopupIndex(-1);
    getAllListingData();
  };
  const handleSampleVerificationDelete = async () => {
    let deleteBody = {
      sv_id: row.sv_id,
    };
    let res = await deleteDataFromApi(sampleverificationDeleteApi, deleteBody);

    if (res?.data?.status === 200) {
      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    setIsDelete(false);
    setPopupIndex(-1);
    getAllListingData();
  };
  const handleSFMDelete = async () => {
    let deleteBody = {
      sfm_id: row.sfm_id,
    };
    let res = await deleteDataFromApi(SFMDeleteApi, deleteBody);

    if (res?.data?.status === 200) {
      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    setIsDelete(false);
    setPopupIndex(-1);
    getAllListingData();
  };
  const handleinternalcertificateDelete = async () => {
    let deleteBody = {
      ic_id: row.ic_id,
    };
    let res = await deleteDataFromApi(InternalCertificateDeleteApi, deleteBody);

    if (res?.data?.status === 200) {
      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    setIsDelete(false);
    setPopupIndex(-1);
    getAllListingData();
  };
  const handleInvoiceDelete = async () => {
    let deleteBody = {
      im_id: row.im_id,
    };
    let res = await deleteDataFromApi(InvoiceDeleteApi, deleteBody);

    if (res?.data?.status === 200) {
      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    setIsDelete(false);
    setPopupIndex(-1);
    getAllListingData();
  };
  const handleDownloadJRF = async () => {
    let bodyData = {
      jrf_id: id,
    };
    let res = await postDataFromApi(JRFPDFDownloadApi, bodyData, "", 1);
    if (res?.status === 200) {
      let pdfDate = "JRF" + id + "_" + getFormatedDate(new Date(), "", 1);
      const blob = new Blob([res.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = pdfDate + ".pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    setIsDelete(false);
    setPopupIndex(-1);
  };
  const handleViewAllReports = (jiId, jrfId) => {
    let idToPass = jiId || jrfId;
    navigate(`/jrfListing/all-reports-preview/${encryptDataForURL(idToPass)}`);
    setPopupIndex(-1);
  };
  const openDeletePopup = () => {
    let headingMsg = "Confirmation!";
    let titleMsg = "";
    if (actionType == "Delete") {
      headingMsg = formConfig?.popupMessages?.delete?.headerMsg;
      titleMsg = formConfig?.popupMessages?.delete?.titleMsg;
    } else if (actionType == "Download") {
      headingMsg = formConfig?.popupMessages?.download?.headerMsg;
      titleMsg = formConfig?.popupMessages?.download?.titleMsg;
    }
    return (
      <DeleteConfirmation
        isOpen={isDelete}
        handleClose={setIsDelete}
        handleConfirm={() =>
          actionType == "Download" ? handleDownloadJRF() : handleDeleteData()
        }
        popupMessage={titleMsg}
        popupHeading={headingMsg}
        actionType={actionType}
      />
    );
  };

  const checkOPSHeadData = () => {
    if (["SU", "OPS_ADMIN", "BH", "SA", "CCPA"].includes(user?.role)) {
      return false;
    } else if (
      user?.logged_in_user_info?.usr_id === row?.["fk_useropsexecutiveid"] ||
      (row["fk_useropsexecutives"] || [])?.includes(
        user?.logged_in_user_info?.usr_id,
      )
    ) {
      return false;
    }
    return true;
  };

  const chkActionVisibility = (
    rolePermissions,
    module,
    subModuleType,
    permission,
    value = "",
  ) => {

    if (["documents", "view", "history"].includes(value.toLowerCase())) {
      if (["SA", 'CCPA'].includes(user?.role)) {
        return true;
      }
    }
    if (["history"].includes(value.toLowerCase())) {
      if (['LR', 'LC', 'DTM', ...CommonTMRoles].includes(user?.role)) {
        return false
      }
    }
    let isVisbile = false;
    if (
      permission &&
      isModuelePermission(rolePermissions, module, permission)
    ) {
      if (module == "jrf") {
        if (value.toLowerCase() === "edit") {
          if (["SU"].includes(user?.role)) {
            return !["saved", "rejected"].includes(row.jrf_status);
          }
          if (row.jrf_is_request_for_cancel) {
            return false;
          }
          let data = {
            BU: ["saved", "rejected"],
            LR: ["saved"],
            SU: [],
            SA: [],
            CCPA: [],
          };
          if (data[user?.role].includes(row.jrf_status)) {
            isVisbile = true;
          }
        } else if (value.toLowerCase() === "delete") {
          if (row.jrf_is_request_for_cancel) {
            return false;
          }
          let data = {
            BU: ["saved", "rejected"],
            LR: [],
            SU: [],
            SA: [],
            CCPA: [],
          };
          if (data[user?.role].includes(row.jrf_status)) {
            isVisbile = true;
            if (["saved"].includes(row.jrf_status) && row.jrf_is_ops) {
              isVisbile = false;
            }
          }
        } else if (value.toLowerCase() === "reject") {
          let data = {
            BU: [],
            LR: ["accepted"],
            SU: [],
            SA: [],
            CCPA: [],
          };
          if (data[user?.role].includes(row.jrf_status)) {
            isVisbile = true;
          }
        } else {
          isVisbile = true;
        }
      } else if (module == "sampleinward") {
        if (value.toLowerCase() === "edit") {
          if (["SU"].includes(user?.role)) {
            return !["created", "saved"].includes(row.jrf_status);
          }
          let data = {
            LR: ["created", "saved"],
            SU: [],
            SA: [],
            CCPA: [],
          };
          if (data[user?.role].includes(row.smpl_status)) {
            isVisbile = true;
          }
        }
        else if (value.toLowerCase() === "edit assignment") {
          if (user?.role == 'LR') {
            return ['assigned', 'test memo created'].includes(row.smpl_status)
          }
          else if (["SU"].includes(user?.role)) {
            return !["created", "saved", 'inwarded', 'assigning'].includes(row.smpl_status)
          }
          return false
        }
        else {
          isVisbile = true;
        }
      } else if (module == "internalcertificate") {
        if (value.toLowerCase() === "edit") {
          let data = {
            LR: ["rejected", "saved"],
            TM: [],
            STM: [],
            QM: [],
            SQM: [],
            SLC: [],
            DTM: [],
            LC: [],
            SU: [],
            SA: [],
            CCPA: [],
          };
          if (data[user?.role].includes(row.status)) {
            isVisbile = true;
          }
        }
        else if (value == "Amendment Report") {
          if (!['LR', 'SU'].includes(user?.role)) return
          isVisbile = false;
          if (['SU'].includes(user?.role) && row?.ic_is_amendent_report) {
            isVisbile = true;
          }

          // if (row?.ic_is_amendent_report && ['saved'].includes(row?.ic_amendent_data_json?.status))
          //   isVisbile = true;

        }
        else if (value == "View Amendment") {
          isVisbile = false;
          if (row?.ic_is_amendent_report)
            isVisbile = true;
        }
        else if (value == "View Amendment Logs") {
          isVisbile = false;
          // if (row?.ic_is_amendent_report)
          //   isVisbile = true;
        }
        else if (value == "Preview Amendment Report") {
          isVisbile = false;
          if (row?.ic_is_amendent_report)
            isVisbile = true;
        }
        else if (value == "Initiate Amendment") {
          isVisbile = false;
          if (!row?.ic_is_amendent_report && ['TM', 'QM'].includes(user?.role) && row.status == "publish")
            isVisbile = true;
        }
        else {
          isVisbile = true;
        }
      } else if (
        module == "jobinstruction" ||
        moduleType === "jioperationjsonb" ||
        moduleType === "invoice"
      ) {

        if (["CreditNoteList", "invoice"].includes(subModuleType)) {

          if (["edit", "delete"].includes(value.toLowerCase())) {
            let data = {
              BU: ["Saved", "debit_save"],
              LR: ["Saved", "debit_save"],
            }
            if (data[user?.role] && data[user?.role].includes(row?.im_status)) {
              isVisbile = true;
            }
          } else if (["view"].includes(value.toLowerCase())) {
            isVisbile = true;
          } else if (["Share Invoice"].includes(value.toLowerCase())) {
            isVisbile = ["LR", "BU"].includes(user?.role);
          } else if (["create debit note"].includes(value.toLowerCase())) {
            if (
              ["invoice_generated"].includes(row?.im_status) &&
              !row?.im_is_debit_created
            ) {
              isVisbile = ["LR", "BU"].includes(user?.role);
            }
          } else if (["edit debit note"].includes(value.toLowerCase())) {
            if (["debit_save"].includes(row?.im_status)) {
              isVisbile = ["LR", "BU"].includes(user?.role);
            }
          } else if (["courier details"].includes(value.toLowerCase())) {
            if (!["Saved"].includes(row?.im_status)) {
              isVisbile = ["LR", "BU"].includes(user?.role);
            }
          } else if (["create credit note"].includes(value.toLowerCase())) {
            if (["invoice_generated"].includes(row?.im_status)) {
              isVisbile =
                ["LR", "BU"].includes(user?.role) &&
                (!row?.im_is_credit_created ||
                  ["LR", "BU"].includes(
                    row?.im_credit_note_json?.im_credit_next_approval,
                  ));
            }
          } else if (["view credit note"].includes(value.toLowerCase())) {
            isVisbile =
              !["SA", 'CCPA'].includes(user?.role) && row?.im_is_credit_created;
          } else if (["add new comment"].includes(value.toLowerCase())) {
            isVisbile = !["SA", 'CCPA'].includes(user?.role);
          } else if (["download draft"].includes(value.toLowerCase())) {
            if (["Saved"].includes(row?.im_status)) {
              isVisbile = true;
            }

          } else {
            isVisbile = false;
          }
          if (["SU"].includes(user?.role)) {
            if (['invoice'].includes(subModuleType)) {
              if (['edit'].includes(value.toLowerCase())) {
                isVisbile = true
              }
            }
          }

          return isVisbile;
        } else if (subModuleType == "commercialCertificate") {
          if (value.toLowerCase() === "delete") {
            let data = {
              BU: ["saved"],
            };
            if (data?.[user?.role] && data?.[user?.role].includes(status)) {
              isVisbile = false;
            } else {
              isVisbile = false;
            }
          } else if (value.toLowerCase() === "edit certi.") {
            if (row.cc_is_request_for_cancel) {
              return false;
            }
            if (["published"].includes(status) && ["SU"].includes(user.role)) {
              isVisbile = true;
            }
          } else if (value === "Request Cancellation") {
            if (row.cc_is_request_for_cancel) {
              return false;
            }

            if (!["cancelled"].includes(status) && ["BU"].includes(user.role) && !row.cc_is_request_for_cancel) {
              isVisbile = true;
            }
          } else if (value.toLowerCase() === "edit config.") {
            if (
              ["published"].includes(status) &&
              ["SU"].includes(user.role) &&
              getLMSOperationActivity().includes(
                getActivityCode(row.activity_code).toLowerCase(),
              ) && !row?.cc_is_physical
            ) {
              isVisbile = true;
            }
          }
          else if (value === "View Config. Details") {
            if (
              getLMSOperationActivity().includes(
                getActivityCode(row.activity_code).toLowerCase(),
              ) && !row?.cc_is_physical
            ) {
              isVisbile = true;
            } else {
              isVisbile = false;
            }
          }
          else if (["With OCR Certificate", "Certificate Download", "Download Custom Format", "Upload Custom Format", "Delete Custom Format"].includes(value)) {
            // if (["saved", "cancelled"].includes(status)) {
            // isVisbile = true

            // }
            // else {
            isVisbile = false
            // }
          }
          else {

            isVisbile = true;
          }
          // return isVisbile;
        } else {
          if (value.toLowerCase() != "view" && checkOPSHeadData()) {
            return false;
          }
          if (value.toLowerCase() === "edit") {
            if (row.ji_is_request_for_cancel) {
              return false;
            }
            let data = {
              BU: ["posted", "accepted"],
              OPS_ADMIN: ["saved", "created", "pre-analysis", "analysis"],
              SU: ["posted", "accepted"],
            };
            if (data?.[user?.role]?.includes(status)) {
              isVisbile = true;
            }
          } else if (value.toLowerCase() === "delete") {
            let data = {
              BU: [],
              OPS_ADMIN: ["saved"],
              SU: [],
              SA: [],
              CCPA: [],
            };
            if (data?.[user?.role]?.includes(status)) {
              isVisbile = true;
            }
          } else if (value.toLowerCase() === "history") {
            let data = {
              BU: ["rejected"],
              OPS_ADMIN: ["rejected"],
              SU: [],
              SA: [],
              CCPA: [],
            };
            if (data?.[user?.role] && !data?.[user?.role]?.includes(status)) {
              isVisbile = true;
            }
          } else if (module === "internalcertificate") {
            if (!["SU"].includes(user?.role)) {
              isVisbile = true;
            }
          } else if (module === "sampleinward") {
            if (!["SU"].includes(user?.role)) {
              isVisbile = true;
            }
          } else {
            isVisbile = true;
          }
        }

      } else if (module == "consortiumorder") {
        if (value.toLowerCase() === "view") {
          isVisbile = true;
        } else if (value.toLowerCase() === "edit") {
          let data = {
            BU: ["saved"],
            OPS_ADMIN: ["saved"],
            SU: [],
          };
          if (data?.[user?.role]?.includes(status)) {
            isVisbile = true;
          }
        } else if (value.toLowerCase() === "delete") {
          let data = {
            BU: ["saved"],
            OPS_ADMIN: ["saved"],
            SU: [],
          };
          if (data?.[user?.role]?.includes(status)) {
            isVisbile = true;
          }
        } else if (value.toLowerCase() === "documents") {
          // if (module == "jobinstruction" || moduleType === "jioperationjsonb") {
          //   if (value.toLowerCase() != "view" && checkOPSHeadData()) {
          //     return false
          //   }
          //   let data = {
          //     BU: ['rejected', 'cancel'],
          //     "OPS_ADMIN": ["rejected", "saved", "created", "pre-analysis", "analysis", 'cancel'],
          //     "SA": ["rejected", "saved", "created", "pre-analysis", "analysis", 'cancel']
          //   };
          //   if (!data?.[user?.role]?.includes(status)) {
          //     isVisbile = true;
          //   }
          // }
          // else {
          isVisbile = true;
          // }
        } else if (value.toLowerCase() === "man power") {

          if (!["CP", "BH"].includes(user?.role)) {
            isVisbile = true;
          }
        } else if (value.toLowerCase() === "commercial certificate") {
          isVisbile = true;
        } else if (value.toLowerCase() === "history") {
          isVisbile = true;
        }
      } else if (module === "purchaseReq") {
        if (["Delete"].includes(value)) {
          if (!getPurchaseManager(module, "delete")) {
            return false;
          }
        } else if (["Edit"].includes(value)) {
          if (
            !getPurchaseManager(module, "change") &&
            ["PM"].includes(user?.role) &&
            row.req_status === "Posted"
          ) {
            return false;
          }
        }
        isVisbile = true;
      } else if (module == "tender") {
        isVisbile = true;
        if (["edit", "delete"].includes(value.toLowerCase())) {
          if (["SA", "CCPA"].includes(user?.role)) {
            isVisbile = false;
          }
        }
      } else if (module === "allotment") {
        if (value.toLowerCase() === "edit") {
          if (["SU"].includes(user?.role)) {
            return !["created", "saved"].includes(row.jrf_status);
          }
          return false;
        }
        isVisbile = true;
      } else if (module === "testmemomain") {
        if (value.toLowerCase() === "edit") {
          if (["SU"].includes(user?.role)) {
            return ["results", "certified", "verified"].includes(row.status);
          }
          return false;
        }
        isVisbile = true;
      } else {
        isVisbile = true;
      }
    } else if (module == "calibration") {
      if (["edit", "delete"].includes(value.toLowerCase())) {
        let data = {
          PM: ["saved"],
        };
        if (
          data?.[user?.role]?.includes(status) &&
          getPurchaseManager(
            module,
            ["edit"].includes(value.toLowerCase()) ? "change" : "delete",
          )
        ) {
          isVisbile = true;
        } else {
          isVisbile = false;
        }
      } else {
        isVisbile = true;
      }
    }
    else if (module === "allotment") {
      if (['Cancel'].includes(value)) {
        isVisbile = ['allotted'].includes(status)
      }
      else {
        isVisbile = false
      }
    } else if (module == "amc") {
      if (["view", "delete", "history"].includes(value.toLowerCase())) {
        isVisbile = true;
      }
    }
    else if (module == "tranferstocks") {
      if (["view", "delete", "edit", "documents"].includes(value.toLowerCase())) {
        isVisbile = true;
      }
    }
    else if (module === "purchaseReq") {
      if (["Documents", "History", "View", "Download", "View PO List"].includes(value)) {
        return true;
      }
      if (["SA", "CCPA"].includes(user?.role)) {
        return ["View", "Download"].includes(value);
      } else if (["View"].includes(value)) {
        return true;
      } else if (["Closed"].includes(status)) {
        return ["View", "History", "Documents", "Download"].includes(value);
      } else if (["Delete"].includes(value)) {
        if (["Saved"].includes(status)) {
          return false;
        }
        if (!getPurchaseManager(module, "delete")) {
          return false;
        }
      } else if (["Edit"].includes(value)) {
        if (
          getPurchaseManager(module, "change") &&
          ["PM"].includes(user?.role) &&
          row.req_status === "Posted"
        ) {
          return true;
        }
      } else if (["PO Create"].includes(value)) {
        if (["Approved"].includes(status)) {
          return true;
        }
      }
      if (["Saved"].includes(status)) {
        if (["Delete", "View", "Documents"].includes(value)) {
          isVisbile = true;
        }
      } else if (["Sent for Approval", "Posted", "Approved"].includes(status)) {
        if (["View", "History", "Documents", "Download"].includes(value)) {
          isVisbile = true;
        }
      }
    } else if (module === "supplier") {
      if (["saved"].includes(status)) {
        isVisbile = true;
        if (
          ["Delete"].includes(value) &&
          !getPurchaseManager(module, "delete")
        ) {
          isVisbile = false;
        }
      } else if (["posted"].includes(status)) {
        if (["View", "History"].includes(value)) {
          isVisbile = true;
        }
      } else {
        isVisbile = false;
      }
    } else if (module === "purchase") {
      if (["SA", "CCPA"].includes(user?.role)) {
        return ["View"].includes(value);
      }
      if (["View", "Documents", "PR Documents", "Download", "PR Download", "PO Items Download", "History"].includes(value)) {
        return true;
      }
      if ((['AUDIT'].includes(user?.role) && row.created_by !== user?.logged_in_user_info?.usr_id)) {
        return false;
      }
      if (['Change Logs'].includes(value)) {
        return ['SU'].includes(user?.role)
      }

      // else if ( ["Pending"].includes(row?.po_vendor_status)){
      //   if (["Send Email","Remind For Not Received"].includes(value)) {

      //   isVisbile = false
      // }
      // }
      else if (["Sent for Approval", "Posted"].includes(status)) {
        if (["View", "History", "Documents"].includes(value)) {
          isVisbile = true;
        }
      } else if (["Reminder for Approval"].includes(value)) {
        isVisbile =
          row?.po_is_overdue &&
          !["Completed", "Pre-Close", "Closed"].includes(row.po_status) &&
          !["Pending"].includes(row?.po_vendor_status);
      } else if (
        ["Accept", "Completed", "Pre-Close", "Closed", "Approved", "Partial"].includes(
          status,
        )
      ) {
        if (
          [
            "Documents",
            "View",
            "Insurance Details",
            "Vendor Rating Details",
            "Download",
            "Send Email",
            "Reminder Email History",
          ].includes(value)
        ) {
          if (["Insurance Details",
            "Vendor Rating Details",
            "Send Email"].includes(value)) {
            const permissionMap = {
              purchaseReq: 'purchaserequisition',
              purchase: 'purchaseorder'
            };

            const permissionType = permissionMap[moduleType];
            const hasPermission = isModuelePermission(rolePermissions, permissionType, "change");

            if (!hasPermission) {
              return
            }
          }
          if (["Send Email"].includes(value)) {
            if (
              ["Pending"].includes(row?.po_vendor_status) &&
              !["Completed", "Pre-Close", "Closed"].includes(status)
            ) {
              isVisbile = true;
            } else {
              isVisbile = false;
            }
          } else if (
            ["Vendor Rating Details", "Insurance Details"].includes(value)
          ) {
            if (row.po_received_qty) {
              isVisbile = true;
            } else {
              isVisbile = false;
            }
          } else if (["Reminder Email History"].includes(value)) {
            if (row.po_reminder_count) {
              isVisbile = true;
            } else {
              isVisbile = false;
            }
          } else {
            isVisbile = true;
          }
        }
      }
      if (
        ["Edit PO"].includes(value) &&
        ((["Rejected"].includes(row.po_vendor_status) &&
          row?.created_by == user?.logged_in_user_info?.usr_id) ||
          (!["Saved", "Reject", "Cancelled"].includes(row.po_vendor_status) &&
            ["SU"].includes(user?.role)))
      ) {
        isVisbile = true;
      }
    } else if (module === "poDashboard") {
      return ["View PO", "View PR"].includes(value);
    } else if (module === "stocks") {
      if (["edit", "delete"].includes(value.toLowerCase())) {
        let data = {
          PM: ["saved"],
          BU: ["saved"],
          LC: ["saved"],
          LR: ["saved"],
        };
        if (
          data[user?.role]?.includes(status) &&
          getPurchaseManager(
            module,
            ["edit"].includes(value.toLowerCase()) ? "change" : "delete",
          )
        ) {
          isVisbile = true;
        } else {
          isVisbile = false;
        }
      } else if (["edit callibration"].includes(value.toLowerCase())) {
        if (
          !getPurchaseManager("stock", "change") ||
          !row?.fk_stock_calibration_id
        ) {
          isVisbile = false;
        }
      } else {
        isVisbile = true;
      }
    } else if (module === "incentives") {
      if (["delete", "view"]?.includes(value)) {
        let data = {
          PM: ["saved"],
          PE: ["saved"],
        };
        if (data[user?.role].includes(status)) {
          isVisbile = true;
        } else {
          isVisbile = false;
        }
      } else {
        isVisbile = true;
      }
    } else if (module === "purchaseItems") {
      isVisbile = true;
      if (["edit", "delete"].includes(value.toLowerCase())) {
        if (
          !getPurchaseManager(
            module,
            ["edit"].includes(value.toLowerCase()) ? "change" : "delete",
          )
        ) {
          isVisbile = false;
        }
      } else if (["edit callibration"].includes(value.toLowerCase())) {
        if (
          !getPurchaseManager(module, "change") ||
          !row?.fk_item_calibration_id
        ) {
          isVisbile = false;
        }
      } else if (["documents"].includes(value.toLowerCase())) {
        if (["SA", "CCPA"].includes(user?.role)) {
          isVisbile = false;
        }
      } else if (["delete"].includes(value.toLowerCase())) {
        isVisbile = false;
      }
    } else if (module === "category") {
      isVisbile = true;
      if (["edit", "delete"].includes(value.toLowerCase())) {
        if (
          !getPurchaseManager(
            module,
            ["edit"].includes(value.toLowerCase()) ? "change" : "delete",
          )
        ) {
          isVisbile = false;
        }
      }
    } else if (module === "lab_parameters") {
      isVisbile = true;
    } else if (module === "userMaster") {
      isVisbile = true;
    } else if (module === "ClientWisePayment") {
      if (['CCPA'].includes(user?.role)) {
        isVisbile = ['View'].includes(value);
      }
      else {
        isVisbile = true;
      }
    } else if (module === "branchmasterList") {
      if (["view", "edit", "delete"].includes(value.toLowerCase())) {
        isVisbile = true;
      }
    } else if (module === "departmentmasterList") {
      if (["view", "edit", "delete"].includes(value.toLowerCase())) {
        isVisbile = true;
      }
    } else if (module === "ClientDetails") {
      isVisbile = true;
    } else if (module === "OnAccountDetails") {
      isVisbile = true;
    } else if (module === "tender") {
      isVisbile = true;
      if (["edit", "delete"].includes(value.toLowerCase())) {
        if (["SA", "CCPA"].includes(user?.role)) {
          isVisbile = false;
        }
      }
    } else if (module === "creditNoteModule") {
      isVisbile = true;
      if (['OPS_ADMIN'].includes(user?.role)) {
        return !['Delete', 'Edit'].includes(value)
      }

      if (["Delete"]?.includes(value)) {
        let data = {
          BU: ["saved"],
          LR: ["saved"],
        };
        if (!data?.[user?.role]) {
          return false
        }
        if (data[user?.role] && !data[user?.role].includes(status)) {
          isVisbile = false;
        }
      }
      if (["Edit"]?.includes(value)) {
        let data = {
          SU: ["tally-created", 'Completed']
        };
        if (!data?.[user?.role]) {
          return false
        }
        if (data[user?.role] && !data[user?.role].includes(status)) {
          isVisbile = false;
        }
      }
    } else if (module === "consortiumorder") {
      if (['CCPA'].includes(user?.role)) {
        isVisbile = ['View'].includes(value);
      }
      else {
        isVisbile = true;
      }
    } else if (module === "clientInvoices") {
      if (["view", "history"].includes(value.toLowerCase())) {
        isVisbile = true;
      } else if (["view invoice"].includes(value.toLowerCase())) {
        isVisbile = row.im_invoiceurl
      }
    }
    else if (module === "vendorRating") {
      isVisbile = true;
    }
    else if (moduleType === "sampleverification") {
      if (value === "Documents") {
        isVisbile = row.has_reject_remark;
      }
      else {
        isVisbile = true;
      }
    }
    else if (moduleType === "TPIMain") {
      if (value === "Edit") {
        isVisbile = ['SU'].includes(user?.role) && ['completed'].includes(status);
      }
      else {
        isVisbile = true;
      }
    }
    else if (moduleType === "jobCosting") {
      isVisbile = true
      if (value === "View Certificates") {
        let parsedData = JSON.parse(
          row?.certificate_data,
        );
        parsedData = Array.isArray(parsedData)
          ? parsedData.join(", ")
          : row?.certificate_data;
        isVisbile = parsedData ? true : false;
      }
    } else {

      if (value.toLowerCase() === "download") {

        let data = {
          BU: ["posted", "saved"],
          LR: ["posted", "saved"],
          SU: ["posted", "saved"],
        };
        if (data[user?.role] && !data[user?.role].includes(row?.jrf_status)) {
          isVisbile = true;
        }
      } else if (

        value.toLowerCase() === "pdf" &&
        (formConfig?.listView?.moduleType === "sfm" ||
          formConfig?.listView?.moduleType === "testmemomain")
      ) {
        // console.log("###34", value)
        let data = {
          TM: ["certified", "results", "verified"],
          STM: ["certified", "results", "verified"],
          QM: ["certified", "results", "verified"],
          SQM: ["certified", "results", "verified"],
          SLC: ["certified", "results", "verified", "completed"],
          LR: ["certified", "results", "verified"],
          DTM: ["certified", "results", "verified", "completed"],
          LC: ["completed"],
          SU: ["certified", "results", "verified", "completed"],
          CCPA: ["certified", "results", "verified", "completed"],
        };
        if (
          user?.all_roles?.main_role_id &&
          user?.all_roles?.other_roles?.length
        ) {
          if (formConfig?.listView?.moduleType === "testmemomain") {
            data?.[user?.role]?.push("results");
          }
        }
        if (
          data[user?.role] &&
          data[user?.role].includes(row.status || row.sfm_status)
        ) {
          isVisbile = true;
        }
      } else if (value.toLowerCase() === "history") {
        if (module == "jobinstruction" || moduleType === "jioperationjsonb") {
          if (["SU"].includes(user?.role)) {
            return true;
          }
          if (value.toLowerCase() != "view" && checkOPSHeadData()) {
            return false;
          }
          let data = {
            BU: ["rejected"],
            OPS_ADMIN: ["rejected"],
          };
          if (data[user?.role] && !data[user?.role].includes(status)) {
            isVisbile = true;
          }
        } else {
          isVisbile = true;
        }
      } else if (
        value.toLowerCase() === "pdf" &&
        (moduleType === "sfm" || moduleType === "testmemomain")
      ) {

        let data = {
          TM: ["certified"],
          LR: ["certified"],
          DTM: ["certified"],
          LC: ["completed"],
          CCPA: ["completed"],
        };

        if (
          data[user?.role] &&
          (data[user?.role].includes(row?.status) ||
            data[user?.role].includes(row?.sfm_status))
        ) {
          isVisbile = true;
        }
      } else if (value.toLowerCase() === "documents") {

        isVisbile = true;
        // if (module == "jobinstruction" || moduleType === "jioperationjsonb") {
        //   if (value.toLowerCase() != "view" && checkOPSHeadData()) {
        //     return false
        //   }
        //   let data = {
        //     BU: ['rejected'],
        //     "OPS_ADMIN": ["rejected", "saved", "created", "pre-analysis", "analysis"],
        //     "SU": ["rejected", "saved", "created", "pre-analysis", "analysis"],
        //     "SA": ["rejected", "saved", "created", "pre-analysis", "analysis"],
        //     "BH": ["rejected", "saved", "created", "pre-analysis", "analysis"],
        //   };
        //   if (data[user?.role] && !data[user?.role].includes(status)) {
        //     isVisbile = true;
        //   }
        // }
        // else if (module == "jrf") {
        //   let data = {
        //     BU: [],
        //     LR: [],
        //     SU: []
        //   };
        //   if (data[user?.role] && !data[user?.role].includes(status)) {
        //     isVisbile = true;
        //   }
        // }
        // else {
        //   isVisbile = true;
        // }
      } else if (value.toLowerCase() === "all reports") {
        isVisbile = true;
      } else if (value.toLowerCase() === "man power") {
        isVisbile = true;
      }
      else if (value.toLowerCase() === "view") {

        isVisbile = true;
      }
      else if (value.toLowerCase() === "commercial certificate") {
        isVisbile = true;
      }
      // else if (value.toLowerCase() === "rake details") {
      //   isVisbile = true;
      // }
      // else if (value.toLowerCase() === "view") {
      //   if (["generated"].includes(status)) {
      //     isVisbile = true;
      //   }
      // }
      else if (value.toLowerCase() === "view") {
        if (moduleType === "TPIMain") {
          isVisbile = true;
        }
      } else if (value.toLocaleLowerCase() === "change logs") {
        if (["SU", "CCPA"].includes(user.role)) {
          if (subModuleType == "commercialCertificate") {
            return !["rejected"].includes(status) && ["SU"].includes(user.role);
          } else {
            isVisbile = true;
          }
        }
      }
    }
    if (["jobinstruction", "jioperationjsonb"].includes(moduleType)) {

      if (
        ["Request Cancellation"].includes(value) && subModuleType !== "commercialCertificate"
      ) {
        if (['OPS_ADMIN'].includes(user?.role) && ["created"].includes(row.status) && !row.ji_is_request_for_cancel) {
          isVisbile = true
        }
        else {
          isVisbile = user?.role === "BU" && (user?.logged_in_user_info?.usr_id === row["fk_useropsexecutiveid"] || row["fk_useropsexecutives"].includes(user?.logged_in_user_info?.usr_id)) && !['cancel'].includes(status) && !row.ji_is_request_for_cancel;
        }
      }
    }
    else if (["jrf"].includes(moduleType)) {
      if (
        ["Request Cancellation"].includes(value)
      ) {
        if (row.jrf_is_request_for_cancel) {
          return false;
        }
        isVisbile = user?.role === "LR" && !(["created", "saved", 'inwarded', 'assigning', 'assigned', 'test memo created'].includes(row?.inward_details?.smpl_status) || ['posted', 'accepted'].includes(row.jrf_status) && row?.jrf_lab_detail?.lab_is_compliant);
      }
      else if (["Cancel JRF"].includes(value)) {
        isVisbile = user?.role === "LR" && (["created", "saved", 'inwarded', 'assigning', 'assigned', 'test memo created'].includes(row?.inward_details?.smpl_status) || ['posted', 'accepted'].includes(row?.jrf_status) && row?.jrf_lab_detail?.lab_is_compliant);
      }
    }
    // if (["SA","SU"].includes(user?.role)) {
    //   if (["jobinstruction", "jioperationjsonb"].includes(moduleType)) {
    //     if (
    //       ["Cancel Job"].includes(value)
    //     ) {
    //       isVisbile = !['cancel'].includes(status);
    //     }
    //   }
    // }
    if (["SU"].includes(user?.role)) {
      if (["sfm", "internalcertificate"].includes(moduleType)) {
        if (
          ["edit"].includes(value.toLowerCase()) &&
          ["completed", "publish"].includes(status)
        ) {
          isVisbile = true;
        }
      }
      else if (['invoice'].includes(subModuleType) && ['invoice'].includes(moduleType)) {
        if (['edit'].includes(value.toLowerCase())) {
          isVisbile = true
        }
      }
    }

    // return true
    return isVisbile;
  };
  const chkSubListVisibility = (from, moduleType, value, subModuleType) => {
    if (subModuleType == "commercialCertificate") {
      let isVisbile = true;
      if (value.toLowerCase() === "delete") {
        if (row.cc_is_request_for_cancel) {
          return false;
        }
        let data = {
          BU: ["saved"],
        };
        if (data?.[user?.role] && data?.[user?.role].includes(status)) {
          isVisbile = true;
        } else {
          isVisbile = false;
        }
      } else if (value.toLowerCase() === "edit certi.") {
        if (row.cc_is_request_for_cancel) {
          return false;
        }
        if (!["rejected"].includes(status) && ["SU"].includes(user.role)) {
          isVisbile = true;
        } else {
          isVisbile = false;
        }
      }
      else if (value.toLowerCase() === "Cancel") {
        if (!["cancelled"].includes(status) && ["BU"].includes(user.role)) {
          isVisbile = true;
        } else {
          isVisbile = false;
        }
      } else if (value.toLowerCase() === "edit config.") {
        if (row.cc_is_request_for_cancel || row?.cc_is_physical) {
          return false;
        }
        if (
          !["rejected"].includes(status) &&
          ["SU"].includes(user.role) &&
          getLMSOperationActivity().includes(
            getActivityCode(row.activity_code).toLowerCase(),
          )
        ) {
          isVisbile = true;
        } else {
          isVisbile = false;
        }
      } else if (value === "View Config. Details") {
        if (
          getLMSOperationActivity().includes(
            getActivityCode(row.activity_code).toLowerCase(),
          ) && !row?.cc_is_physical
        ) {
          isVisbile = true;
        } else {
          isVisbile = false;
        }
      }
      // else if (value === "Certificate Download") {
      //   console.log("$%^")
      //       if (["saved"].includes(status)) {
      //         isVisbile = true

      //       }
      //       else {
      //         isVisbile = false
      //       }
      //     } 
      else if (value.toLocaleLowerCase() === "change logs") {
        isVisbile =
          !["rejected"].includes(status) && ["SU"].includes(user.role);
      }
      else if (value === "Request Cancellation") {
        if (row.cc_is_request_for_cancel) {
          return false;
        }
        return ["BU"].includes(user.role)
      }
      else if (["Download Custom Format", "Delete Custom Format"].includes(value)) {
        if (row.cc_is_external || !row.cc_is_custom_format_file) {
          return false;
        }
      }
      else if (value === "Upload Custom Format") {
        if (row.cc_is_external || !['published'].includes(row.status) || row.cc_is_custom_format_file) {
          return false;
        }
      } else {
        isVisbile = true;
      }
      return isVisbile;
    }
    if (value?.toLowerCase() === "delete" && row?.status === "completed") {
      return false;
    } else if (value?.toLowerCase() === "rake details") {
      // if (operationMode === "RAKE") {
      //   if (getActivityCode(row?.activity_master?.activity_code).toLowerCase() === getRakeOperations('QAss')) {
      //     return true
      //   }
      // }
      return false;
    } else {
      if (from === "subListTable") {
        if (["CP", "BH"].includes(user?.role)) {
          return false;
        } else {
          return true;
        }
      }
    }
  };
  const popupRef = useRef(null);
  const [dynamicTop, setDynamicTop] = useState(0);

  useEffect(() => {
    if (popupRef.current) {
      const popupHeight = popupRef.current.offsetHeight;
      setDynamicTop(-popupHeight); // Set `top` to negative of the height
    }
  }, [isBottom]); // Recalculate if `isBottom` changes
  const EditCertificate = async (isView, isCancel = false, iscustomformatupload) => {
    let pageStatus = isView ? "View" : "Edit";
    let cancelquery = `&useForCancel=${encryptDataForURL(isCancel ? 1 : 0)}&iscustomformatupload=${encryptDataForURL(iscustomformatupload)}`;
    const redirectUrl = getOperationActivityUrl(row?.operationmode?.ops_code);
    if (row.cc_is_external) {
      navigate(
        `${redirectUrl}confirugation-certificate/${encryptDataForURL(
          row.fk_jiid,
        )}/${encryptDataForURL(row.fk_jisid)}/${encryptDataForURL(
          row.cc_id,
        )}?status=${encryptDataForURL(
          pageStatus,
        )}&OperationType=${encryptDataForURL(row.activity_code)}` +
        "&isExternal=" +
        encryptDataForURL(1) +
        "&isCustomMode=" +
        encryptDataForURL(1) +
        "&operationMode=" +
        encryptDataForURL(row?.operationmode?.ops_code) +
        (pageStatus === "View"
          ? "&action=" + encryptDataForURL(pageStatus)
          : "") + cancelquery,
      );
      return;
    }
    if (
      !getLMSOperationActivity().includes(
        getActivityCode(row.activity_code).toLowerCase(),
      )
    ) {
      navigate(
        `${redirectUrl}confirugation-certificate/${encryptDataForURL(
          row.fk_jiid,
        )}/${encryptDataForURL(row.fk_jisid)}/${encryptDataForURL(
          row.cc_id,
        )}?status=${encryptDataForURL(
          pageStatus,
        )}&OperationType=${encryptDataForURL(row.activity_code)}` +
        "&OperationType=" +
        encryptDataForURL(OperationType) +
        "&operationMode=" +
        encryptDataForURL(row?.operationmode?.ops_code) +
        (pageStatus === "View"
          ? "&action=" + encryptDataForURL(pageStatus)
          : "") + cancelquery,
      );
    } else {
      if (row?.cc_is_physical) {
        navigate(
          `${redirectUrl}confirugation-certificate/${encryptDataForURL(
            row.fk_jiid,
          )}/${encryptDataForURL(row.fk_jisid)}/${encryptDataForURL(
            row.cc_id,
          )}?status=${encryptDataForURL(
            pageStatus,
          )}&OperationType=${encryptDataForURL(row.activity_code)}` +
          "&OperationType=" +
          encryptDataForURL(OperationType) +
          "&isUseForPhysical=" +
          encryptDataForURL(1) +
          "&operationMode=" +
          encryptDataForURL(row?.operationmode?.ops_code) +
          (pageStatus === "View"
            ? "&action=" + encryptDataForURL(pageStatus)
            : "") + cancelquery,
        );
        return;
      }
      navigate(
        `${redirectUrl}confirugation-certificate/${encryptDataForURL(
          row.fk_jiid,
        )}/${encryptDataForURL(row.fk_jisid)}/${encryptDataForURL(
          row.cc_id,
        )}?status=${encryptDataForURL(pageStatus)}` +
        "&OperationType=" +
        encryptDataForURL(row.activity_code) +
        "&operationMode=" +
        encryptDataForURL(row?.operationmode?.ops_code) +
        (pageStatus === "View"
          ? "&action=" + encryptDataForURL(pageStatus)
          : "") + cancelquery
      );
    }
  };
  const getActionLabel = (label) => {
    if (subModuleType == "commercialCertificate") {
      if (["Upload Custom Format"].includes(label)) {
        if (!row.cc_is_external && row.cc_is_custom_format_file) {
          return "Re-Upload Custom Format"
        }
      }
    }
    switch (moduleType) {
      case "internalcertificate":
        switch (label) {
          case "Preview Report":
            if (row?.ic_is_amendent_report) {
              return "Preview Last Report"
            }
            break;
          case "Amendment Report":
            if (row?.ic_is_amendent_report) {
              return "Edit Amendment"
            }
          default:
            break;
        }
        break;


      default:
        break;
    }
    return label
  }
  return (
    <div
      ref={popupRef}
      className={"popupOptions"}
      style={isBottom ? { position: "absolute", top: `${dynamicTop}px` } : {}}
    >
      {actions.map((action, actionIndex) => {
        if (
          status === "cancelled" &&
          !["View", "Change Logs", "History", 'Cancel Certificate', 'View Certi. Details', 'View Config. Details', 'Change Logs', 'Certificate Download', "Preview Report", "With OCR Certificate", "With OCR Report", "Download Custom Format", "Download Report"].includes(action.value)
        ) {
          return null;
        }
        if (['With OCR Certificate', "With OCR Report", "Upload Custom Format", "Download Custom Format", "Delete Custom Format", "Download Report"].includes(action.value) && !['SU'].includes(user?.role)) {
          return null
        }
        return (action.value &&
          action.value !== "" &&
          action.type === "icon" &&
          action.status !== "assignmentview" &&
          chkActionVisibility(
            rolePermissions,
            section.moduleType,
            section.subModuleType,
            action.permission,
            action.value,
          )) ||
          chkSubListVisibility(
            from,
            section.moduleType,
            action.value,
            section.subModuleType,
          ) ? (
          <div key={"sample-inward-" + actionIndex}>
            <button
              type="button"
              className="nonNativeButton2"
              aria-label="Sample Inward Action Button"
              onClick={() =>
                moduleType === "sampleinward"
                  ? handleClick(action.status, action.value)
                  : handleClick(action.value)
              }
            >
              <i className={action.label}></i>
              {getActionLabel(action.value)}
            </button>
          </div>
        ) : action.status === "assignmentview" &&
          row["smpl_status"] === "assigned" ? (
          <div key={"actionIndex-" + actionIndex}>
            <button
              type="button"
              className="nonNativeButton2"
              aria-label="Assignment View Button"
              onClick={() =>
                moduleType === "sampleinward"
                  ? handleClick(action.status, action.value)
                  : handleClick(action.value)
              }
            >
              <i className={action.label}></i>
              {action.value}
            </button>
          </div>
        ) : action.status === "JICommercialList" ? (
          <div key={"actionIndex-" + actionIndex}>
            <button
              type="button"
              className="nonNativeButton2"
              aria-label="Assignment View Button"
              onClick={() => handleClick(action.value)}
            >
              <i className={action.label}></i>
              {action.value}
            </button>
          </div>
        ) : action.status === "vesseListView" ? (
          <div key={"actionIndex-" + actionIndex}>
            <button
              type="button"
              className="nonNativeButton2"
              aria-label="Assignment View Button"
              onClick={() => handleClick(action.value)}
            >
              <i className={action.label}></i>
              {action.value}
            </button>
          </div>
        ) : null;
      })}
      {isDelete && openDeletePopup()}
    </div>
  );
};
PopupOptions.propTypes = {
  popupActions: PropTypes.arrayOf(PropTypes.object),
  setPopupIndex: PropTypes.func,
  id: PropTypes.string,
  row: PropTypes.object,
  section: PropTypes.string,
  getAllListingData: PropTypes.func,
  formConfig: PropTypes.object,
  type: PropTypes.string,
  sampleInwardFormId: PropTypes.string,
  model: PropTypes.object,
  isBottom: PropTypes.bool,
  status: PropTypes.string,
  setDontClick: PropTypes.func,
};

export default PopupOptions;
